import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import Slider from 'react-slick';
import '../CSS/Global.css';
import trust from "../Images/trust_2x.gif"
import verified from "../Images/verified.gif"
import {
    Badge, Box, Button, Divider, Flex, Heading, IconButton, Image, Modal, ModalBody, ModalCloseButton, ModalContent,
    ModalFooter, ModalHeader, ModalOverlay, Select, Stack, Text, Textarea, useDisclosure, useToast, useBreakpointValue, VStack, HStack, Grid, SimpleGrid, Input, Spinner
} from '@chakra-ui/react';
import user from '../Images/user.jpg'
import pagevendor from "../Images/trending.png"
import axios from 'axios';
import Header from './Header';
import { useGlobalContext } from './Context/GlobalContext';
import DetailImageMobile from "./DetailImageMobile"
import CryptoJS from 'crypto-js';
import { CloseIcon, StarIcon, CheckCircleIcon, TimeIcon, PhoneIcon, ChevronRightIcon, ChevronLeftIcon } from '@chakra-ui/icons';
import { getAuth, RecaptchaVerifier, signInWithPhoneNumber } from "firebase/auth";
import { app } from "./firebase";
import { Helmet } from "react-helmet-async";
import { apiAssetUrl, getApiBaseUrl, getProductGalleryPaths, parseFormImageList } from "../utils/apiAssetUrl";
import { resolveIsLocationCategory } from "../utils/locationCategory";
import LocationDetailsReadOnlyModal from "./LocationDetailsReadOnlyModal";
import { buildListingMetaTags } from "../utils/listingMeta";
import { getCanonicalOrigin } from "../utils/canonicalOrigin";
import { getFilledSocialLinks, hasAnySocialLink, parseSocialMediaLinks } from "../utils/socialMediaLinks";
import { consumeValidatedImagesFromEvent, IMAGE_ACCEPT_ATTR, IMAGE_TYPES_HELPER_TEXT } from "../utils/validatedImageChakra";
import {
    firstUnavailableInRange,
    isDateObjUnavailable,
    isYmdUnavailable,
    normalizeUnavailableDatesList,
} from "../utils/vendorUnavailableDates";
import { BOOKING_CITY_OPTIONS, matchBookingCityOption } from "../utils/bookingCities";
import { format } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

/** True if rich-text HTML has no visible text (matches listing validation expectations). */
function isHtmlDescriptionEmpty(html) {
    if (!html || typeof html !== "string") return true;
    const text = html.replace(/<[^>]*>/g, "").replace(/&nbsp;/gi, " ").trim();
    return text.length === 0;
}

/** Icons for listing section tabs (Font Awesome solid) */
const DETAIL_TAB_ICONS = {
    product: "fa-layer-group",
    overview: "fa-align-left",
    services: "fa-puzzle-piece",
    "quick-info": "fa-circle-info",
    review: "fa-star",
    portfolio: "fa-images",
};

function getDetailTabLabel(tab, additionalServicesLabel) {
    const labels = {
        product: "Services",
        overview: "Overview",
        services: additionalServicesLabel,
        "quick-info": "Quick info",
        review: "Review",
        portfolio: "Portfolio",
    };
    return labels[tab] || tab;
}

/** Stable parsing for react-datepicker `selected` (new Date() each render causes infinite updates). */
function parseYmdLocalDate(ymd) {
    if (!ymd) return null;
    const [y, m, d] = ymd.split("-").map(Number);
    if (!y || !m || !d) return null;
    return new Date(y, m - 1, d);
}

// --- Re-written PhotoUploadModal (Enhanced UI & Corrected Prop Usage) ---
const PhotoUploadModal = ({ isOpen, onClose, setIsModalOpen, uploadedFiles, storeId, detailVendorGet, setUploadedFiles }) => {
    const toast = useToast();
    const [isSubmitting, setIsSubmitting] = useState(false);
    const url = getApiBaseUrl()
    if (!isOpen) return null;

    const handleLocalFiles = (e) => {
        void consumeValidatedImagesFromEvent(e, toast).then((accepted) => {
            if (accepted.length) setUploadedFiles((prev) => [...prev, ...accepted]);
        });
    };

    const handleSubmitAllImages = async () => {
        if (uploadedFiles.length === 0) {
            toast({ title: "No files selected", status: "warning", duration: 3000, isClosable: true });
            return;
        }
        setIsSubmitting(true);
        const formData = new FormData();
        uploadedFiles.forEach((file) => formData.append("formImages", file));

        try {
            await axios.put(
                `${url}/store/add-store-images/${storeId}`,
                formData,
                { headers: { "Content-Type": "multipart/form-data" } }
            );

            toast({ title: "Images added successfully!", status: "success", duration: 3000, isClosable: true });
            setUploadedFiles([]);
            setIsModalOpen(false);
            detailVendorGet();

        } catch (error) {
            console.error("Error uploading images:", error);
            toast({ title: "Failed to upload images.", status: "error", duration: 5000, isClosable: true });
        } finally {
            setIsSubmitting(false);
        }
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader borderBottom="1px solid" borderColor="gray.100">
                    <Heading size="lg" color="brand.600">Upload Photos</Heading>
                </ModalHeader>
                <ModalCloseButton />
                <ModalBody py={6}>
                    <VStack spacing={4} align="stretch">
                        <Input
                            type="file"
                            accept={IMAGE_ACCEPT_ATTR}
                            multiple
                            onChange={handleLocalFiles}
                            p={1}
                            variant="filled"
                        />
                        <Text fontSize="sm" color="gray.600" mt={2}>{IMAGE_TYPES_HELPER_TEXT}</Text>
                        {uploadedFiles.length > 0 && (
                            <Box w="100%" p={4} bg="brand.50" borderRadius="md" border="1px solid" borderColor="brand.200">
                                <Text fontWeight="bold" mb={2}>Uploaded Files ({uploadedFiles.length}):</Text>
                                <VStack align="start" spacing={1} maxH="150px" overflowY="auto">
                                    {uploadedFiles.map((file, index) => (
                                        <Text key={index} fontSize="sm" isTruncated maxW="100%"><i className="fa-solid fa-file-image" style={{ marginRight: "5px", color: "#0041FF" }}></i> {file.name}</Text>
                                    ))}
                                </VStack>
                            </Box>
                        )}
                    </VStack>
                </ModalBody>
                <ModalFooter>
                    <Button colorScheme="brand" mr={3} onClick={handleSubmitAllImages} isLoading={isSubmitting} loadingText="Uploading..." isDisabled={uploadedFiles.length === 0}>
                        Submit
                    </Button>
                    <Button variant="ghost" onClick={onClose} isDisabled={isSubmitting}>Close</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    );
};


// --- Main Component ---
const DetailPageVendor = () => {
    // --- State & Hooks (Retained all original state variables) ---
    const [activeTab, setActiveTab] = useState('product');
    const [isVisible, setIsVisible] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const navigate = useNavigate();
    const [rating, setRating] = useState(0);
    const [description, setDescription] = useState("");
    const { isOpen, onOpen, onClose } = useDisclosure();
    const { isOpen: isModal1Open, onOpen: openModal1, onClose: closeModal1 } = useDisclosure();
    const { isOpen: isModal2Open, onOpen: openModal2, onClose: closeModal2 } = useDisclosure();
    const login = (() => {
        try {
            const raw = localStorage.getItem("login");
            if (!raw) return {};
            const p = JSON.parse(raw);
            return p && typeof p === "object" ? p : {};
        } catch {
            return {};
        }
    })();
    const [storeSingle, setSinglevendor] = useState({})
    const [permanent_IDuser, setPermanentIdUser] = useState()
    const [product, setProduct] = useState([])
    const [deletingProductId, setDeletingProductId] = useState(null)
    const [productGallery, setProductGallery] = useState({
        open: false,
        urls: [],
        index: 0,
        title: '',
    })
    const [isLocationListing, setIsLocationListing] = useState(false)
    const [locationDetailView, setLocationDetailView] = useState({ open: false, product: null })
    const detailTabBtnRefs = useRef({})
    const additionalServicesTabLabel = useBreakpointValue({ base: "Add-ons", md: "Additional Services" })
    const [ratingData, setRatingData] = useState([])
    const [storemainname, setStorename] = useState()
    const [averageRating, setAverageRating] = useState();
    const [amount, setAmount] = useState()
    const { id, name } = useParams();
    const [plan, setPlan] = useState([]);
    const [planobject, setPlanObject] = useState({});
    const [ispaid, setIsPaid] = useState(false);
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [formData, setFormData] = useState({
        storeName: "", address: "", contactNo: "", whatsappNo: "", overview: "",
        services: [], businessHours: { days: "", open: "", close: "" },
        category: "", subCategory: ""
    });
    const [categories, setCategories] = useState([]);
    const [subCategories, setSubCategories] = useState([]);
    const [claimreq, setClaimRequest] = useState("");
    const [load, setLoad] = useState(true);
    const auth = getAuth(app);
    // USER MOBILE VERIFICATION STATES
    const [profileDetails, setProfileDetails] = useState({});
    const [isOtpModalOpen, setIsOtpModalOpen] = useState(false);

    const [otp, setOtp] = useState("");
    const [confirmationResult, setConfirmationResult] = useState(null);
    const [afterOtpAction, setAfterOtpAction] = useState(null); // { type, number }
    const [isResendEnabled, setIsResendEnabled] = useState(false);
    const [timer, setTimer] = useState(30);

    const url = getApiBaseUrl()
    /** System UI stack — readable, “premium” mobile profile feel (similar intent to major social apps). */
    const uiFontStack = '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif';

    const toast = useToast();

    useEffect(() => {
        if (!storeSingle || (!storeSingle.category && !storeSingle.subcategory)) {
            setIsLocationListing(false);
            return;
        }
        let cancelled = false;
        void resolveIsLocationCategory(url, storeSingle.category, storeSingle.subcategory).then((v) => {
            if (!cancelled) setIsLocationListing(!!v);
        });
        return () => { cancelled = true; };
    }, [storeSingle?.category, storeSingle?.subcategory, url]);

    const [isMobileModalOpen, setIsMobileModalOpen] = useState(false);
    const [mobileInput, setMobileInput] = useState("");
    const [afterAction, setAfterAction] = useState(null);

    // Book now modal state
    const { isOpen: isBookingOpen, onOpen: openBookingModal, onClose: closeBookingModal } = useDisclosure();
    const [bookingStep, setBookingStep] = useState(1);
    const [bookingForm, setBookingForm] = useState({
        production_name: "", hirer_name: "", authorized_contact: "", project_type: "",
        reporting_date: "", reporting_time: "", completion_date: "", total_units: "", location_address: "",
        name: "", email: "", phone: "", inquirer_city: "",
    });
    const [bookingOtp, setBookingOtp] = useState("");
    const [bookingOtpSent, setBookingOtpSent] = useState(false);
    const [bookingSubmitting, setBookingSubmitting] = useState(false);

    const bookingReportingSelected = useMemo(
        () => parseYmdLocalDate(bookingForm.reporting_date),
        [bookingForm.reporting_date]
    );
    const bookingCompletionSelected = useMemo(
        () => parseYmdLocalDate(bookingForm.completion_date),
        [bookingForm.completion_date]
    );

    const handleProtectedAction = async (type, number) => {
        await fetchDataUser();
        console.log(profileDetails)
        if (!profileDetails.mobile || profileDetails.mobile.trim() === "") {
            setAfterAction({ type, number });
            setMobileInput("");
            setIsMobileModalOpen(true);
        } else {
            proceedAfterVerification(type, number);
        }
    };

    const proceedAfterVerification = (type, number) => {
        if (type === "call") {
            PostLead(type);
            window.location.href = `tel:${number}`;
        } else if (type === "whatsapp") {
            handleWhatsAppClick(storeSingle.businessDetails?.businessName, number);
        }
    };


    const saveMobileNumber = async () => {
        if (!mobileInput || mobileInput.length !== 10) {
            toast({ title: "Enter a valid 10-digit mobile number", status: "warning" });
            return;
        }

        profileDetails.mobile = mobileInput;
        await handleProfileSave();

        toast({ title: "Mobile number updated successfully!", status: "success" });

        setIsMobileModalOpen(false);
        proceedAfterVerification(afterAction.type, afterAction.number);
    };

    const { fetchCartData, cart, totalCartItem, Admobile, whatsappNo } = useGlobalContext();
    // console.log(Admobile, whatsappNo)
    // --- Utility Functions (Fixed and added basic implementations where missing) ---

    const fetchDataCategory = async () => {
        try {
            const response = await fetch(`${url}/category/getcategory`);
            if (!response.ok) {
                console.warn("fetchDataCategory: HTTP", response.status);
                return;
            }
            const res = await response.json();
            const list = Array.isArray(res)
                ? res
                : Array.isArray(res?.data)
                  ? res.data
                  : [];
            setCategories(list);
        } catch (error) {
            console.warn("fetchDataCategory:", error?.message || error);
        }
    };

    // Original handleSubCategoryChange and handleCategoryChange logic was integrated/redundant,
    // but retaining original function signatures for safety.
    const handleSubCategoryChange = (e) => { /* Logic integrated into handleInputChange */ };
    const handleServiceChange = (index, value) => {
        const updatedServices = [...formData.services];
        updatedServices[index] = value;
        setFormData(prevState => ({ ...prevState, services: updatedServices }));
    };
    const handleBusinessHoursChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            businessHours: { ...prevState.businessHours, [name]: value },
        }));
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "category") {
            const selectedCat = categories.find(cat => cat.category_name === value);
            setSubCategories(selectedCat?.associatedsubcategory || []);
            setFormData(prevState => ({ ...prevState, category: value, subCategory: "" }));
        } else if (name === "subCategory") {
            setFormData(prevState => ({ ...prevState, subCategory: value }));
        } else {
            setFormData(prevState => ({ ...prevState, [name]: value }));
        }
    };

    const fetchDataUser = async () => {
        if (!login?.permanent_ID) {
            setProfileDetails({});
            return;
        }
        try {
            const response = await fetch(
                `${getApiBaseUrl()}/register/singleuser/${login.permanent_ID}`
            );
            const res = await response.json();
            setProfileDetails(res || {});
        } catch (error) {
            console.error("fetchDataUser:", error);
        }
    };

    const addServiceField = () => { setFormData(prevState => ({ ...prevState, services: [...prevState.services, ''] })); };
    const removeServiceField = (index) => {
        const updatedServices = formData.services.filter((_, idx) => idx !== index);
        setFormData({ ...formData, services: updatedServices });
    }
    const closeEdit = () => setIsEditOpen(false);
    const openEdit = () => setIsEditOpen(true);


    const handleProfileSave = async () => {
        const formData = new FormData();
        formData.append('name', profileDetails.name || "");
        formData.append('mobile', profileDetails.mobile || "");
        formData.append('email', profileDetails.email || "");
        formData.append('account_number', profileDetails.account_number || "");
        formData.append('beneficary_name', profileDetails.beneficary_name || "");
        formData.append('ifsc_code', profileDetails.ifsc_code || "");
        formData.append('bank_name', profileDetails.bank_name || "");

        // if (selectedFile) {
        //     formData.append('profilePic', selectedFile);
        // }

        try {
            await fetch(`${getApiBaseUrl()}/register/change/${profileDetails.id}`, {
                method: "PUT",
                body: formData,
            });

            await fetchDataUser();
            console.log("Profile updated");
        } catch (error) {
            console.error("handleProfileSave:", error);
        }
    };


    const handleFormSubmit = async (e) => {
        e.preventDefault();
        if (isHtmlDescriptionEmpty(formData.overview)) {
            toast({ title: "Please add an overview / description", status: "warning", duration: 4000, isClosable: true });
            return;
        }
        try {
            const addressParts = formData.address.split(",").map(s => s.trim());
            const updatedData = {
                businessDetails: {
                    businessName: formData.storeName, description: formData.overview,
                    buildingName: addressParts[0] || "", street: addressParts[1] || "",
                    city: addressParts[4] || "", state: addressParts[5] || "", pincode: addressParts[6] || "",
                },
                contactDetails: { mobile: formData.contactNo, whatsapp: formData.whatsappNo },
                additionalServices: formData.services,
                businessTiming: {
                    timeSlots: [{ day: formData.businessHours.days, openTime: formData.businessHours.open, closeTime: formData.businessHours.close }],
                },
                category: formData.category, subcategory: formData.subCategory,
            };
            await axios.put(`${url}/store/change/${storeSingle.id}`, updatedData);
            toast({ description: "Store details updated successfully!", status: "success", duration: 5000, isClosable: true });
            detailVendorGet();
            closeEdit();
        } catch (error) {
            console.error("Error updating store details:", error);
            toast({ description: "Failed to update store details. Please try again.", status: "error", duration: 5000, isClosable: true });
        }
    };

    const detailVendorGet = async () => {
        setLoad(true);
        try {
            const response = await fetch(`${url}/store/getstorelist/${id}/${encodeURIComponent(name || '')}`);
            const res = await response.json();

            if (!res) {
                setSinglevendor(null);
                setLoad(false);
                return;
            }

            const parsedData = {
                ...res,
                additionalServices: typeof res.additionalServices === 'string' ? JSON.parse(res.additionalServices || "[]") : (res.additionalServices || []),
                businessDetails: typeof res.businessDetails === 'string' ? JSON.parse(res.businessDetails || "{}") : (res.businessDetails || {}),
                businessTiming: typeof res.businessTiming === 'string' ? JSON.parse(res.businessTiming || "{}") : (res.businessTiming || {}),
                contactDetails: typeof res.contactDetails === 'string' ? JSON.parse(res.contactDetails || "{}") : (res.contactDetails || {}),
                formImages: parseFormImageList(res.formImages),
                servicesDetails: typeof res.servicesDetails === 'string' ? JSON.parse(res.servicesDetails || "{}") : (res.servicesDetails || {}),
                planObject: typeof res.planObject === 'string' ? JSON.parse(res.planObject || "{}") : (res.planObject || {}),
                catgeoryArray: typeof res.catgeoryArray === 'string' ? JSON.parse(res.catgeoryArray || "{}") : (res.catgeoryArray || {}),
                subcatgeoryArray: typeof res.subcatgeoryArray === 'string' ? JSON.parse(res.subcatgeoryArray || "{}") : (res.subcatgeoryArray || {}),
                socialMediaLinks: parseSocialMediaLinks(res.socialMediaLinks),
                unavailable_dates: normalizeUnavailableDatesList(res.unavailable_dates),
            };

            setPermanentIdUser(parsedData.user_id);
            setStorename(parsedData.businessDetails?.businessName);
            setSinglevendor(parsedData);
            FetchProductdata(parsedData.user_id);
            fetchRatingData(parsedData.user_id);
        } catch (error) {
            console.log(error);
            setSinglevendor(null);
        } finally {
            setLoad(false);
        }
    };

    const decrypt = (encryptedData, iv) => { return 'decrypted_data'; };
    const handleStarClick = (index) => { setRating(index + 1); onOpen(); };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!login?.permanent_ID) {
            toast({ description: "Please log in to submit a review.", status: "info", duration: 4000, position: "top-center", isClosable: true });
            onClose();
            navigate("/login");
            return;
        }
        try {
            if (permanent_IDuser === login.permanent_ID) {
                toast({ description: `Self review not allowed`, status: 'warning', duration: 5000, position: 'top-center', isClosable: true });
                return;
            }
            await fetch(`${url}/rating`, {
                method: "POST", headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ user_id: login.permanent_ID, user_name: login.name, rating_point: rating, description, store_id: permanent_IDuser, store_name: storemainname })
            });
            onClose();
            fetchRatingData(permanent_IDuser); // Pass the ID for data fetch
            toast({ description: `Reviewed Successfully`, status: 'success', duration: 5000, position: 'top-center', isClosable: true });
            setDescription("");
        } catch (error) { console.log(error); toast({ description: `Review submission failed.`, status: 'error', duration: 5000, isClosable: true }); }
    };

    const handleTabClick = (tabName) => {
        setActiveTab(tabName);
        const element = document.getElementById(tabName);
        if (element) {
            element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
        requestAnimationFrame(() => {
            const pill = detailTabBtnRefs.current[tabName];
            pill?.scrollIntoView?.({ behavior: "smooth", block: "nearest", inline: "center" });
        });
    };

    const FetchProductdata = async (user_idmain) => {
        try {
            const response = await fetch(`${url}/product/getproduct/${user_idmain}`);
            const res = await response.json();
            setProduct(Array.isArray(res) ? res : []);
        } catch (error) { console.log(error); }
    };

    const handleDeleteProduct = async (ele) => {
        if (!ele?.id || login.permanent_ID !== permanent_IDuser) return;
        const label = (ele.product_name || "this item").trim();
        if (!window.confirm(`Delete "${label}"? This cannot be undone.`)) return;
        setDeletingProductId(ele.id);
        try {
            await axios.delete(`${url}/product/delete-product/${ele.id}`, {
                params: { user_id: login.permanent_ID },
            });
            toast({
                title: "Deleted",
                description: `${label} was removed.`,
                status: "success",
                duration: 4000,
                isClosable: true,
            });
            await FetchProductdata(permanent_IDuser);
        } catch (e) {
            toast({
                title: "Delete failed",
                description: e?.response?.data?.message || e.message,
                status: "error",
                duration: 5000,
                isClosable: true,
            });
        } finally {
            setDeletingProductId(null);
        }
    };

    const openProductGallery = (ele) => {
        const paths = getProductGalleryPaths(ele);
        const urls = paths.map((p) => apiAssetUrl(url, p)).filter(Boolean);
        if (!urls.length) return;
        setProductGallery({
            open: true,
            urls,
            index: 0,
            title: (ele.product_name || 'Product').trim() || 'Product',
        });
    };

    const closeProductGallery = () => setProductGallery((g) => ({ ...g, open: false }));

    const stepProductGallery = (delta) => {
        setProductGallery((g) => {
            if (!g.urls.length) return g;
            const next = (g.index + delta + g.urls.length) % g.urls.length;
            return { ...g, index: next };
        });
    };

    const fetchRatingData = async (rating_id) => {
        try {
            const response = await fetch(`${url}/rating/${rating_id}`);
            const res = await response.json();
            const data = res?.data || [];
            const totalRatingPoints = data.reduce((sum, rating) => sum + parseFloat(rating.rating_point || 0), 0);
            setRatingData(data);
            setAverageRating(data.length > 0 ? totalRatingPoints / data.length : 0);
        } catch (error) { console.log(error); }
    };

    const fetchDataPrice = async () => {
        try {
            const response = await fetch(`${getApiBaseUrl()}/trendingprice`);
            const res = await response.json();

            setAmount(res.data[0].trending_price);
        } catch (error) {
            console.log(error);
        }
    };
    const loadScript = (src) => {
        return new Promise((resolve) => {
            const script = document.createElement("script");
            script.src = src;
            script.onload = () => {
                resolve(true);
            };
            script.onerror = () => {
                resolve(false)
            }
            document.body.appendChild(script);
        })
    };
    const handleMaketrending = async () => {
        try {
            let orderId = "11" + Math.floor(Math.random() * Math.floor(Math.random() * Date.now()));

            // Load the Razorpay SDK
            let res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");

            if (!res) {
                alert("Razorpay SDK Failed to load. Are you online?");
                return;
            }

            // Define payment details
            let paymentDetails = {

                user_id: storeSingle.user_id,
                user_phone: storeSingle.user_name,
                transaction_id: orderId,
                amount: amount * 100,
                currency: "INR",
                payment_capture: 1,
                payment_mode: "online",
            };

            // Create order options
            let options = {
                key: "rzp_test_zEWr4dOpfx4w2F",
                currency: paymentDetails.currency,
                amount: paymentDetails.amount,
                name: "Film Location",
                description: "Transaction",
                handler: async function (response) {

                    if (response.razorpay_payment_id) {
                        // Payment was successful
                        paymentDetails.razorpay_payment_id = response.razorpay_payment_id;
                        paymentDetails.status = 'Paid';
                        let result = await axios.post(`${getApiBaseUrl()}/trending`, paymentDetails);

                        if (!result.data.isError) {
                            // Redirect to the success page
                            //   checkPaymentStatus();
                            closeModal1();
                            // window.location.href = `/delivery/${orderId}`; // Replace "/success-page" with the URL of your success page
                        } else {
                            alert("Server error. Are You Online");
                            //   window.location.href = "/error-page"; // Redirect to an error page
                        }
                    } else {
                        // Handle payment failure or cancellation

                        paymentDetails.status = 'Failed';
                        await axios.post(`${getApiBaseUrl()}/trending`, paymentDetails);
                        closeModal1();
                        // window.location.href = "/error-page"; // Redirect to an error page
                    }
                },
                prefill: {
                    email: "filmlocation@gmail.com",
                    contact: "7757858388"
                },
                notes: {
                    address: "Razorpay Corporate Office"
                },
                theme: {
                    color: "#f8402a"
                },
                modal: {
                    ondismiss: function () {
                        // Handle Razorpay modal close
                        // setLoad(false);
                        closeModal1();
                    },
                },
            };

            // Initialize Razorpay payment object and open checkout
            let paymentObject = new window.Razorpay(options);
            paymentObject.on('payment.failed', function (response) {
                paymentDetails.status = 'Failed';
                axios.post(`${getApiBaseUrl()}/trending`, paymentDetails)
                    .then(() => {
                        closeModal1();
                    }).catch(error => {
                        navigate("/") // Redirect to an error page
                    });
            });

            paymentObject.open();

        } catch (error) {
            console.log(error);
        }
    }
    const handleClickClaim = async () => {
        try {
            const response = await fetch(`${getApiBaseUrl()}/claim-request`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    user_id: login.permanent_ID,
                    user_phone: login.name,
                    store_name: storeSingle.businessDetails.businessName,
                    store_details: storeSingle
                })
            })
            // const res = await response.json();
            if (response.ok) {
                const res = await response.json();
                toast({
                    description: "Claim sent successfully",
                    status: 'warning',
                    duration: 5000,
                    position: 'top-center',
                    isClosable: true,
                });
                checkClaimStatus();
            }
            else if (response.status === 400) {
                const res = await response.json();
                toast({
                    description: res.message,
                    status: 'warning',
                    duration: 5000,
                    position: 'top-center',
                    isClosable: true,
                });
                console.log(res);
            }


        } catch (error) {
            console.log(error)
        }
    }
    const checkClaimStatus = async () => {
        if (!login?.permanent_ID) return;
        try {
            const baseUrl = getApiBaseUrl();
            const response = await fetch(`${baseUrl}/claim-request/matchingclaim/${login.permanent_ID}/${id}/${encodeURIComponent(name || '')}`);
            const res = await response.json();
            if (res.single && res.single.status) {
                setClaimRequest(res.single.status);
            }
        } catch (error) {
            console.log(error);
        }
    }
    const fetchCheckPay = async () => {
        if (!login?.permanent_ID) return;
        try {
            const response = await fetch(`${getApiBaseUrl()}/pay-storefees/users/${login.permanent_ID}`);
            const res = await response.json();
            console.log("storepay", res);
            const encryptedData = res.data;

            // Decrypt the data
            const decryptedData = decrypt(encryptedData.data, encryptedData.iv);
            const parsedData = JSON.parse(decryptedData);
            console.log(parsedData);

            // Ensure decrypted data is not empty
            if (parsedData.length === 0) {
                console.log("Error: No payment records found.");
                setIsPaid(true);
                return;
            }

            // Get current date in Indian Standard Time (IST)
            const currentDate = new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));

            let isPaidAndValid = false;

            // Iterate over all payment records
            for (const payment of parsedData) {
                const { status, startDate, endDate } = payment;

                // Check if the payment status is 'Paid'
                if (status === "Paid") {
                    const start = new Date(startDate);
                    const end = new Date(endDate);

                    // Check if current date is within the valid range
                    if (currentDate >= start && currentDate <= end) {
                        console.log("Access granted!");
                        isPaidAndValid = true;
                        break; // Stop checking further if valid payment is found
                    }
                }
            }

            if (isPaidAndValid) {
                setIsPaid(false);
            } else {
                console.log("Error: No valid payment found.");
                setIsPaid(true);
            }
        } catch (error) {
            console.log(error);
        }
    };
    const handlePayment = async () => { /* ... subscription payment logic ... */ }

    const handleAddCart = async (product) => {
        if (!login?.permanent_ID) {
            toast({ description: "Please log in to add items.", status: "info", duration: 4000, position: "top-center", isClosable: true });
            navigate("/login");
            return;
        }
        try {
            const response = await fetch(`${url}/cart`, {
                method: "POST", headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    user_id: login.permanent_ID,
                    user_phone: login.name,
                    store_id: permanent_IDuser,
                    product: product,
                    cod: storeSingle.cod_percentage
                })
            });
            const res = await response.json();
            if (response.ok) {
                toast({ description: res.message, status: 'success', duration: 5000, position: 'top-center', isClosable: true });
                fetchCartData();
            } else if (response.status === 400) {
                toast({ description: res.message, status: 'warning', duration: 5000, position: 'top-center', isClosable: true });
            }
        } catch (error) { console.log(error) }
    };

    const handleWhatsAppClick = (storeName, mobile) => {
        const message = `Hi, I would like to inquire about ${storeName}`;
        const phoneNumber = `+91${mobile}`; // Replace with the store's WhatsApp number
        window.open(`https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
    };

    const handleShareClick = (name, number, idN) => {
        const shareData = {
            title: "Check this out!",
            text: `Visit our website for more details! ${getApiBaseUrl()}/detail-listing/${idN}/${name}`,
            url: `${getApiBaseUrl()}/detail-listing/${idN}/${name}` // Replace with your website URL
        };

        // Check if the browser supports the navigator.share API
        if (navigator.share) {
            navigator.share(shareData)
                .then(() => console.log('Successfully shared'))
                .catch((error) => console.error('Error sharing', error));
        } else {
            // Fallback: Copy the link to the clipboard for desktop users
            navigator.clipboard.writeText(shareData.text)
                .then(() => alert('Link copied to clipboard!'))
                .catch((error) => console.error('Could not copy link', error));
        }
    };
    const calculateYearsInBusiness = (businessDate) => {
        const businessDateObject = new Date(businessDate); // Parse the business date
        const currentDate = new Date(); // Get the current date

        const diffInMilliseconds = currentDate - businessDateObject; // Difference in milliseconds
        const millisecondsPerYear = 1000 * 60 * 60 * 24 * 365.25; // Average milliseconds in a year (accounting for leap years)

        const yearsInBusiness = diffInMilliseconds / millisecondsPerYear; // Convert to years
        return Math.round(yearsInBusiness); // Round to the closest year
    };
    const getPlan = async () => {
        try {
            const response = await fetch(`${getApiBaseUrl()}/vendor-storepricing/all/pricingall`)
            const res = await response.json();
            setPlan(res);
            console.log(res);
        } catch (error) {
            console.log(error);
        }

    }

    const formatTime = (time) => {
        if (!time || time === "N/A" || time === "") return "N/A";
        const [hour, minute] = time.split(':').map(Number);
        const period = hour >= 12 ? 'PM' : 'AM';
        const adjustedHour = hour % 12 || 12;
        return `${adjustedHour}:${minute < 10 ? '0' : ''}${minute} ${period}`;
    };

    // --- Effects ---
    useEffect(() => {
        if (storeSingle) {
            setFormData({
                storeName: storeSingle.businessDetails?.businessName || "",
                address: [
                    storeSingle.businessDetails?.buildingName, storeSingle.businessDetails?.street, storeSingle.businessDetails?.area,
                    storeSingle.businessDetails?.landmark, storeSingle.businessDetails?.city, storeSingle.businessDetails?.state,
                    storeSingle.businessDetails?.pincode,
                ].filter(Boolean).join(", "),
                contactNo: storeSingle.contactDetails?.mobile || "",
                whatsappNo: storeSingle.contactDetails?.whatsapp || "",
                overview: storeSingle.businessDetails?.description || "",
                services: storeSingle.additionalServices || [],
                businessHours: {
                    days: storeSingle.businessTiming?.timeSlots?.[0]?.day || "",
                    open: storeSingle.businessTiming?.timeSlots?.[0]?.openTime || "",
                    close: storeSingle.businessTiming?.timeSlots?.[0]?.closeTime || "",
                },
                category: storeSingle.category || "",
                subCategory: storeSingle.subcategory || ""
            });
            const initialCategory = categories.find(cat => cat.category_name === storeSingle.category);
            if (initialCategory) {
                setSubCategories(initialCategory.associatedsubcategory || []);
            }
        }
    }, [storeSingle, categories]);

    useEffect(() => {
        void detailVendorGet();
        void fetchDataPrice();
        void fetchDataCategory();
        void checkClaimStatus();
        void fetchCheckPay();
        void getPlan();
        void fetchDataUser();
    }, []);





    const sendOtp = async () => {
        if (!mobileInput || mobileInput.length !== 10) {
            toast({ title: "Enter valid mobile number", status: "warning" });
            return;
        }

        const appVerifier = new RecaptchaVerifier(auth, "recaptcha-container", {
            size: "invisible",
        });

        try {
            const phoneNumber = "+91" + mobileInput;
            const result = await signInWithPhoneNumber(auth, phoneNumber, appVerifier);

            setConfirmationResult(result);
            setIsResendEnabled(false);
            setTimer(30);
            startResendTimer();

            toast({ title: "OTP sent", status: "success" });
        } catch (err) {
            console.error(err);
            toast({ title: "Failed to send OTP", status: "error" });
        }
    };

    const startResendTimer = () => {
        const interval = setInterval(() => {
            setTimer((prev) => {
                if (prev <= 1) {
                    clearInterval(interval);
                    setIsResendEnabled(true);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);
    };


    const verifyOtp = async () => {
        try {
            await confirmationResult.confirm(otp);

            profileDetails.mobile = mobileInput;
            await handleProfileSave(); // Save mobile to backend

            toast({ title: "Mobile verified!", status: "success" });

            setIsOtpModalOpen(false);

            proceedAfterVerification(afterOtpAction.type, afterOtpAction.number);

        } catch (err) {
            toast({ title: "Incorrect OTP", status: "error" });
        }
    };







    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY;
            const detailInfoAnchor = document.getElementById('detail-info-anchor');
            if (detailInfoAnchor) {
                setIsVisible(scrollPosition > detailInfoAnchor.offsetTop + detailInfoAnchor.offsetHeight - 100);
            }
        };
        window.addEventListener('scroll', handleScroll);
        return () => { window.removeEventListener('scroll', handleScroll); };
    }, []);

    const isFreePlan =
        !storeSingle.planObject ||                // null or undefined
        Object.keys(storeSingle.planObject).length === 0 ||  // empty {}
        !storeSingle.planObject.sale_price ||     // 0, null, undefined
        storeSingle.planObject.sale_price <= 0;   // <= 0 explicitly

    const callNumber = isFreePlan
        ? Admobile
        : storeSingle.contactDetails?.mobile;


    const whatsappNumber = isFreePlan
        ? whatsappNo
        : storeSingle.contactDetails?.whatsapp;


    const handleBookingModalOpen = async () => {
        setBookingStep(1);
        setBookingOtpSent(false);
        setBookingOtp("");
        const listingCityPrefill = matchBookingCityOption(storeSingle?.businessDetails?.city || "");
        const baseForm = {
            production_name: "", hirer_name: "", authorized_contact: "", project_type: "",
            reporting_date: "", reporting_time: "", completion_date: "", total_units: "", location_address: "",
            name: "", email: "", phone: "", inquirer_city: listingCityPrefill,
        };
        if (login && login.permanent_ID) {
            await fetchDataUser();
        }
        setBookingForm(baseForm);
        openBookingModal();
    };

    useEffect(() => {
        if (isBookingOpen && login && login.permanent_ID && profileDetails?.name) {
            setBookingForm(prev => ({
                ...prev,
                name: profileDetails.name || prev.name,
                email: profileDetails.email || prev.email,
                phone: profileDetails.mobile || prev.phone,
            }));
        }
    }, [isBookingOpen, profileDetails?.name, profileDetails?.email, profileDetails?.mobile]);

    const handleBookingInputChange = (e) => {
        const { name, value } = e.target;
        setBookingForm(prev => ({ ...prev, [name]: value }));
    };

    const bookingTrim = (v) => (v || "").trim();

    const validateBookingStep1 = () => {
        if (!bookingTrim(bookingForm.production_name)) return "Production/Project name is required.";
        if (!bookingTrim(bookingForm.hirer_name)) return "Hirer (client) name is required.";
        if (!bookingTrim(bookingForm.authorized_contact)) return "Authorized contact is required.";
        if (!bookingTrim(bookingForm.project_type)) return "Project type is required.";
        return null;
    };

    const toastVendorUnavailable = (title) => {
        toast({
            position: "top-center",
            duration: 9000,
            render: ({ onClose }) => (
                <Box bg="red.600" color="white" p={4} borderRadius="md" maxW="sm" boxShadow="lg">
                    <Text fontWeight="bold" mb={1}>
                        {title}
                    </Text>
                    <Text fontSize="sm" mb={3} opacity={0.95}>
                        Vendor not available on selected date
                    </Text>
                    <Button
                        size="sm"
                        variant="outline"
                        borderColor="whiteAlpha.800"
                        color="white"
                        _hover={{ bg: "whiteAlpha.200" }}
                        onClick={() => {
                            onClose();
                            navigate("/contact");
                        }}
                    >
                        Contact Us
                    </Button>
                </Box>
            ),
        });
    };

    const validateBookingStep2 = () => {
        if (!bookingTrim(bookingForm.reporting_date)) return "Reporting date is required.";
        if (!bookingTrim(bookingForm.reporting_time)) return "Reporting time is required.";
        if (!bookingTrim(bookingForm.completion_date)) return "Completion date is required.";
        if (!bookingTrim(bookingForm.total_units)) return "Total units/shifts is required.";
        if (!bookingTrim(bookingForm.location_address)) return "Location address is required.";
        const u = storeSingle.unavailable_dates || [];
        if (bookingForm.reporting_date && isYmdUnavailable(bookingForm.reporting_date, u)) {
            return "The selected date is already booked";
        }
        if (bookingForm.completion_date && isYmdUnavailable(bookingForm.completion_date, u)) {
            return "The selected date is already booked";
        }
        const rangeHit = firstUnavailableInRange(
            bookingForm.reporting_date,
            bookingForm.completion_date,
            u
        );
        if (rangeHit) {
            return `Vendor not available on ${rangeHit.label}`;
        }
        return null;
    };

    const validateBookingStep3Contact = () => {
        if (!bookingTrim(bookingForm.name)) return "Your name is required.";
        if (!bookingTrim(bookingForm.email)) return "Email is required.";
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(bookingTrim(bookingForm.email))) return "Enter a valid email address.";
        if (!bookingTrim(bookingForm.phone)) return "Phone is required.";
        if (!bookingTrim(bookingForm.inquirer_city)) return "Please select your city (we route your booking to premium vendors in that city).";
        return null;
    };

    const sendBookingOtp = async () => {
        const contactErr = validateBookingStep3Contact();
        if (contactErr) {
            toast({ title: contactErr, status: "warning" });
            return;
        }
        try {
            const res = await fetch(`${url}/leads/send-booking-otp`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ email: bookingForm.email }),
            });
            const data = await res.json();
            if (data.success) {
                setBookingOtpSent(true);
                toast({ title: "OTP sent to your email", status: "success" });
            } else {
                toast({ title: data.message || "Failed to send OTP", status: "error" });
            }
        } catch (err) {
            toast({ title: "Failed to send OTP", status: "error" });
        }
    };

    const submitBooking = async () => {
        const step1Err = validateBookingStep1();
        if (step1Err) {
            toast({ title: step1Err, status: "warning" });
            setBookingStep(1);
            return;
        }
        const step2Err = validateBookingStep2();
        if (step2Err) {
            toast({ title: step2Err, status: "warning" });
            setBookingStep(2);
            return;
        }
        const contactErr = validateBookingStep3Contact();
        if (contactErr) {
            toast({ title: contactErr, status: "warning" });
            setBookingStep(3);
            return;
        }
        if (!bookingOtpSent || !bookingTrim(bookingOtp)) {
            toast({ title: "Please verify your email with OTP first", status: "warning" });
            return;
        }
        if (bookingTrim(bookingOtp).replace(/\D/g, "").length !== 6) {
            toast({ title: "Enter the 6-digit OTP", status: "warning" });
            return;
        }
        try {
            const verifyRes = await fetch(`${url}/leads/verify-booking-otp`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    email: (bookingForm.email || "").trim(),
                    otp: (bookingOtp || "").replace(/\D/g, "").slice(0, 6),
                }),
            });
            const verifyData = await verifyRes.json();
            if (!verifyData.success) {
                toast({ title: verifyData.message || "Invalid OTP", status: "error" });
                return;
            }
            setBookingSubmitting(true);
            const formatDate = (d) => {
                if (!d) return "";
                const [y, m, day] = d.split("-");
                return `${day}-${m}-${y}`;
            };
            const formatTime = (t) => {
                if (!t) return "";
                const [h, min] = t.split(":");
                const hour = parseInt(h, 10);
                const ampm = hour >= 12 ? "PM" : "AM";
                const h12 = hour % 12 || 12;
                return `${h12}:${min} ${ampm}`;
            };
            const reporting_datetime = [formatDate(bookingForm.reporting_date), formatTime(bookingForm.reporting_time)].filter(Boolean).join(" at ");
            const completion_date = formatDate(bookingForm.completion_date) || bookingForm.completion_date;
            const payload = {
                name: (bookingForm.name || "").trim(),
                email: (bookingForm.email || "").trim(),
                phone: (bookingForm.phone || "").trim(),
                production_name: bookingForm.production_name,
                hirer_name: bookingForm.hirer_name,
                authorized_contact: bookingForm.authorized_contact,
                project_type: bookingForm.project_type,
                reporting_datetime,
                completion_date,
                reporting_date_iso: bookingForm.reporting_date,
                completion_date_iso: bookingForm.completion_date,
                total_units: bookingForm.total_units,
                location_address: bookingForm.location_address,
                store_id: storeSingle.user_id || storeSingle.id,
                store_name: storeSingle.user_name || storeSingle.businessDetails?.businessName || "",
                store: storeSingle,
                category: storeSingle.category,
                user_id: login?.permanent_ID || "",
                user_name: login?.name || "",
                inquirer_city: bookingTrim(bookingForm.inquirer_city),
            };
            const res = await fetch(`${url}/leads/booking`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(payload),
            });
            const data = await res.json();
            if (res.ok) {
                toast({ title: "Booking submitted successfully!", status: "success", duration: 5000 });
                closeBookingModal();
                setBookingStep(1);
                setBookingOtpSent(false);
            } else if (res.status === 422 && data.code === "NO_VENDOR_MATCH") {
                toast({
                    title: data.message || "No premium vendors found in your city for this category.",
                    status: "warning",
                    duration: 8000,
                    isClosable: true,
                });
            } else {
                const msg = data.missing ? `${data.message}: ${data.missing.join(", ")}` : (data.message || "Booking failed");
                if (
                    data.code === "UNAVAILABLE" ||
                    (typeof msg === "string" &&
                        (msg.includes("Vendor not available") || msg.includes("already booked")))
                ) {
                    toastVendorUnavailable(msg);
                } else {
                    toast({ title: msg, status: "error", duration: 6000 });
                }
            }
        } catch (err) {
            toast({ title: "Booking failed", status: "error" });
        } finally {
            setBookingSubmitting(false);
        }
    };

    const PostLead = async (type) => {
        try {
            const response = await fetch(`${url}/leads`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    email: profileDetails.email,
                    phone: profileDetails.mobile,
                    name: profileDetails.name,
                    user_id: login.permanent_ID,
                    user_name: login.name,
                    store_name: storeSingle.user_name,
                    store_id: storeSingle.user_id,
                    vendor_name: isFreePlan ? "" : storeSingle.user_name,
                    vendor_permanentId: isFreePlan ? "" : storeSingle.user_id,
                    store: storeSingle,
                    type: type
                })
            })
        } catch (error) {
            console.error(error)
        }
    }

    // Strip HTML tags and return plain text
    const getPlainText = (htmlString) => {
        return htmlString.replace(/<[^>]+>/g, "");
    };

    // Check character length
    const isShort = (htmlString) => {
        const text = getPlainText(htmlString);
        return text.length <= 50;
    };

    // Trim plain text preview
    const getPreview = (html) => {
        if (!html) return "";

        // Remove all HTML tags
        const text = html.replace(/<[^>]+>/g, "").trim();

        // Limit the preview
        return text.length > 80 ? text.substring(0, 80) + "..." : text;
    };




    if (load) {
        return (
            <Flex w="100vw" h="100vh" justify="center" align="center" direction="column">
                <Spinner size="xl" color="brand.500" thickness="4px" />
                <Text mt={4} color="gray.600">Loading store details...</Text>
            </Flex>
        );
    }

    if (!storeSingle || !storeSingle.id) {
        return (
            <>
                <Header />
                <Flex w="100%" minH="60vh" justify="center" align="center" direction="column" p={8}>
                    <Text fontSize="xl" color="gray.600" mb={4}>Store not found</Text>
                    <Text color="gray.500" mb={6}>The listing you're looking for may have been removed or doesn't exist.</Text>
                    <Button as={Link} to="/" colorScheme="brand">Back to Home</Button>
                </Flex>
            </>
        );
    }

    const storeImages = storeSingle?.formImages || [];

    const isPortfolioItem = (p) => {
        if (!p) return false;
        if (p.type === 'portfolio') return true;
        if (p.type === 'product') return false;
        if (p.datelaunched) return true;
        if (p.castlist) {
            try {
                const raw = p.castlist;
                if (typeof raw === 'string') {
                    const parsed = JSON.parse(raw || '[]');
                    return Array.isArray(parsed) ? parsed.length > 0 : String(raw).trim().length > 2;
                }
                if (Array.isArray(raw)) return raw.length > 0;
            } catch {
                return String(p.castlist).trim().length > 2;
            }
        }
        return false;
    };

    const portfolioProducts = product.filter(isPortfolioItem);
    const mainProducts = product.filter((p) => !isPortfolioItem(p));

    const isOwner = login.permanent_ID === permanent_IDuser;
    const showProductsSection = mainProducts.length > 0 || isOwner;
    const showPortfolioSection = portfolioProducts.length > 0 || isOwner;

    const ratingTotal = ratingData?.length ?? 0;
    const ratingCountLabel =
        ratingTotal === 0 ? "No ratings yet" : ratingTotal === 1 ? "1 rating" : `${ratingTotal} ratings`;

    const visibleDetailTabs = ["product", "overview", "services", "quick-info", "review", "portfolio"].filter((tab) => {
        if (tab === "services" && (!storeSingle.additionalServices || storeSingle.additionalServices.length === 0)) return false;
        if (tab === "product" && !showProductsSection) return false;
        if (tab === "portfolio" && !showPortfolioSection) return false;
        return true;
    });

    const listingMeta = buildListingMetaTags(storeSingle, {
        canonicalOrigin: getCanonicalOrigin(),
        canonicalPath: `/detail-listing/${id}/${encodeURIComponent(name || storeSingle.businessDetails?.businessName || "listing")}`,
    });
    const firstListingImage = storeImages[0];
    const listingOgImage =
        firstListingImage && listingMeta ? apiAssetUrl(url, firstListingImage) : undefined;

    // ---------------------------------------------
    // --- Render Logic with Enhanced UI ---
    // ---------------------------------------------
    return (
        <>
            {listingMeta && (
                <Helmet prioritizeSeoTags>
                    <title>{listingMeta.title}</title>
                    <meta name="description" content={listingMeta.description} />
                    {listingMeta.keywords ? <meta name="keywords" content={listingMeta.keywords} /> : null}
                    {listingMeta.canonical ? <link rel="canonical" href={listingMeta.canonical} /> : null}
                    <meta property="og:title" content={listingMeta.title} />
                    <meta property="og:description" content={listingMeta.description} />
                    <meta property="og:type" content={listingMeta.ogType} />
                    {listingOgImage ? <meta property="og:image" content={listingOgImage} /> : null}
                    {listingMeta.canonical ? <meta property="og:url" content={listingMeta.canonical} /> : null}
                    <meta name="twitter:card" content={listingOgImage ? "summary_large_image" : "summary"} />
                    <meta name="twitter:title" content={listingMeta.title} />
                    <meta name="twitter:description" content={listingMeta.description} />
                    {listingOgImage ? <meta name="twitter:image" content={listingOgImage} /> : null}
                </Helmet>
            )}

            <Header />

            <Modal isOpen={isMobileModalOpen} onClose={() => setIsMobileModalOpen(false)} isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Update Mobile Number</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Input
                            placeholder="Enter mobile number"
                            value={mobileInput}
                            onChange={(e) => setMobileInput(e.target.value)}
                            mt={2}
                        />
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="brand" onClick={saveMobileNumber}>Save</Button>
                        <Button variant="ghost" onClick={() => setIsMobileModalOpen(false)}>Cancel</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* Book now Modal */}
            <Modal isOpen={isBookingOpen} onClose={closeBookingModal} size="xl" isCentered scrollBehavior="inside">
                <ModalOverlay bg="blackAlpha.600" />
                <ModalContent maxW="640px" maxH="90vh" borderRadius="xl" overflow="hidden">
                    <ModalHeader bg="brand.600" color="white" py={4}>
                        <Flex justify="space-between" align="center">
                            <Text fontSize="xl" fontWeight="bold">Book Now</Text>
                            <HStack spacing={2}>
                                {bookingStep > 1 && bookingStep < 4 && (
                                    <Button size="sm" variant="ghost" color="white" leftIcon={<ChevronLeftIcon />} onClick={() => setBookingStep(s => s - 1)}>Back</Button>
                                )}
                                <ModalCloseButton color="white" />
                            </HStack>
                        </Flex>
                    </ModalHeader>
                    <ModalBody py={6} overflowY="auto">
                        {bookingStep === 1 && (
                            <VStack spacing={4} align="stretch">
                                <Heading size="sm" color="gray.700" borderBottom="2px solid" borderColor="brand.500" pb={2}>1. PROJECT INFORMATION</Heading>
                                <Box><Text fontWeight="medium" mb={1}>Production/Project Name <Text as="span" color="red.500">*</Text></Text><Input name="production_name" value={bookingForm.production_name} onChange={handleBookingInputChange} placeholder="Enter project name" required /></Box>
                                <Box><Text fontWeight="medium" mb={1}>Hirer (Client) Name <Text as="span" color="red.500">*</Text></Text><Input name="hirer_name" value={bookingForm.hirer_name} onChange={handleBookingInputChange} placeholder="Client name" required /></Box>
                                <Box><Text fontWeight="medium" mb={1}>Authorized Contact <Text as="span" color="red.500">*</Text></Text><Input name="authorized_contact" value={bookingForm.authorized_contact} onChange={handleBookingInputChange} placeholder="+91-XXXXX XXXXX" maxLength={15} required /></Box>
                                <Box><Text fontWeight="medium" mb={1}>Project Type <Text as="span" color="red.500">*</Text></Text><Select name="project_type" value={bookingForm.project_type} onChange={handleBookingInputChange} placeholder="Select type" required><option value="Feature Film">Feature Film</option><option value="Ad Film">Ad Film</option><option value="Web Series">Web Series</option><option value="Short Film">Short Film</option><option value="Documentary">Documentary</option><option value="Music Video">Music Video</option><option value="Other">Other</option></Select></Box>
                                <Button colorScheme="brand" rightIcon={<ChevronRightIcon />} onClick={() => { const err = validateBookingStep1(); if (err) { toast({ title: err, status: "warning" }); return; } setBookingStep(2); }} w="full">Next: Booking Logistics</Button>
                            </VStack>
                        )}
                        {bookingStep === 2 && (
                            <VStack spacing={4} align="stretch">
                                <Heading size="sm" color="gray.700" borderBottom="2px solid" borderColor="brand.500" pb={2}>2. BOOKING LOGISTICS</Heading>
                                <HStack spacing={4} w="full" align="flex-start" flexWrap="wrap">
                                    <Box flex={1} minW="140px">
                                        <Text fontWeight="medium" mb={1}>Reporting Date <Text as="span" color="red.500">*</Text></Text>
                                        <DatePicker
                                            selected={bookingReportingSelected}
                                            onChange={(d) =>
                                                setBookingForm((prev) => ({
                                                    ...prev,
                                                    reporting_date: d ? format(d, "yyyy-MM-dd") : "",
                                                }))
                                            }
                                            filterDate={(d) => !isDateObjUnavailable(d, storeSingle.unavailable_dates || [])}
                                            dateFormat="dd-MM-yyyy"
                                            placeholderText="Pick date"
                                            customInput={<Input size="md" />}
                                            calendarClassName="detail-booking-cal"
                                            dayClassName={(date) =>
                                                isDateObjUnavailable(date, storeSingle.unavailable_dates || [])
                                                    ? "vendor-day-blocked"
                                                    : undefined
                                            }
                                        />
                                    </Box>
                                    <Box flex={1} minW="140px">
                                        <Text fontWeight="medium" mb={1}>Time <Text as="span" color="red.500">*</Text></Text>
                                        <Input name="reporting_time" type="time" value={bookingForm.reporting_time} onChange={handleBookingInputChange} required />
                                    </Box>
                                </HStack>
                                <Box>
                                    <Text fontWeight="medium" mb={1}>Completion Date <Text as="span" color="red.500">*</Text></Text>
                                    <DatePicker
                                        selected={bookingCompletionSelected}
                                        onChange={(d) =>
                                            setBookingForm((prev) => ({
                                                ...prev,
                                                completion_date: d ? format(d, "yyyy-MM-dd") : "",
                                            }))
                                        }
                                        filterDate={(d) => {
                                            if (isDateObjUnavailable(d, storeSingle.unavailable_dates || [])) return false;
                                            if (bookingReportingSelected && d < bookingReportingSelected) return false;
                                            return true;
                                        }}
                                        dateFormat="dd-MM-yyyy"
                                        placeholderText="Pick date"
                                        customInput={<Input size="md" />}
                                        calendarClassName="detail-booking-cal"
                                        dayClassName={(date) =>
                                            isDateObjUnavailable(date, storeSingle.unavailable_dates || [])
                                                ? "vendor-day-blocked"
                                                : undefined
                                        }
                                    />
                                </Box>
                                <Box><Text fontWeight="medium" mb={1}>Total Units/Shifts <Text as="span" color="red.500">*</Text></Text><Input name="total_units" value={bookingForm.total_units} onChange={handleBookingInputChange} placeholder="e.g., 5 Rooms / 3 Days / 10 Cars" required /></Box>
                                <Box><Text fontWeight="medium" mb={1}>Location Address <Text as="span" color="red.500">*</Text></Text><Textarea name="location_address" value={bookingForm.location_address} onChange={handleBookingInputChange} placeholder="Full address" rows={2} required /></Box>
                                <Box p={3} bg="gray.50" borderRadius="md" fontSize="sm"><Text fontWeight="bold" mb={2}>FILMEKEE STANDARD INSTRUCTIONS</Text><Text mb={1}>• Check-in Protocol: For Hotels/Stay, a valid Aadhar Card is mandatory for all crew members.</Text><Text mb={1}>• Equipment Quality: All gear must be checked by the Client upon arrival. Any issues must be reported to the Filmekee Helpdesk within 2 hours.</Text><Text mb={1}>• Talent Conduct: Artists must adhere to the call time mentioned. Delays may result in a rating penalty on the Filmekee platform.</Text><Text>• Travel Safety: For Vehicle bookings, ensure the driver's details match the digital ID sent via the Filmekee App.</Text></Box>
                                <Box p={3} bg="blue.50" borderRadius="md" fontSize="sm"><Text fontWeight="bold" mb={2}>LEGAL & COMPLIANCE</Text><Text mb={1}>1. This voucher is generated by Filmekee and acts as a digital Letter of Intent (LOI).</Text><Text mb={1}>2. By proceeding with this booking, both parties agree to the Filmekee Master Service Agreement.</Text><Text mb={1}>3. Payments are secured in the Filmekee Escrow Account and will be released only after the service is marked as "Completed" by the Hirer.</Text><Text>4. Confidentiality: All parties must maintain strict NDA protocols as per Filmekee guidelines.</Text></Box>
                                <Button colorScheme="brand" rightIcon={<ChevronRightIcon />} onClick={() => {
                                    const err = validateBookingStep2();
                                    if (err) {
                                        if (err.includes("already booked") || err.includes("Vendor not available on")) {
                                            toastVendorUnavailable(err);
                                        } else {
                                            toast({ title: err, status: "warning" });
                                        }
                                        return;
                                    }
                                    setBookingStep(3);
                                }} w="full">Next: Contact & Verify</Button>
                            </VStack>
                        )}
                        {bookingStep === 3 && (
                            <VStack spacing={4} align="stretch">
                                <Heading size="sm" color="gray.700" borderBottom="2px solid" borderColor="brand.500" pb={2}>3. CONTACT DETAILS & VERIFICATION</Heading>
                                <Box><Text fontWeight="medium" mb={1}>Your Name <Text as="span" color="red.500">*</Text></Text><Input name="name" value={bookingForm.name} onChange={handleBookingInputChange} placeholder="Full name" required /></Box>
                                <Box><Text fontWeight="medium" mb={1}>Email <Text as="span" color="red.500">*</Text></Text><Input name="email" type="email" value={bookingForm.email} onChange={handleBookingInputChange} placeholder="your@email.com" required /><Button size="sm" variant="link" color="brand.600" mt={1} onClick={() => setBookingStep(2)}>Wrong email? Go back and change</Button></Box>
                                <Box><Text fontWeight="medium" mb={1}>Phone <Text as="span" color="red.500">*</Text></Text><Input name="phone" value={bookingForm.phone} onChange={handleBookingInputChange} placeholder="+91-XXXXX XXXXX" required /></Box>
                                <Box>
                                    <Text fontWeight="medium" mb={1}>Your city <Text as="span" color="red.500">*</Text></Text>
                                    <Text fontSize="xs" color="gray.600" mb={1}>
                                        Choose the city where you are based. It must match the city on the vendor&apos;s store profile for routing.
                                    </Text>
                                    <Select
                                        name="inquirer_city"
                                        placeholder="Select your city"
                                        value={bookingForm.inquirer_city || ""}
                                        onChange={handleBookingInputChange}
                                        bg="white"
                                    >
                                        <option value="">Select your city</option>
                                        {BOOKING_CITY_OPTIONS.map((city) => (
                                            <option key={city} value={city}>
                                                {city}
                                            </option>
                                        ))}
                                    </Select>
                                </Box>
                                {!bookingOtpSent ? (
                                    <Button colorScheme="brand" onClick={sendBookingOtp} w="full" isDisabled={!!validateBookingStep3Contact()}>Send OTP to Email</Button>
                                ) : (
                                    <VStack spacing={2} w="full">
                                        <Input
                                            placeholder="Enter 6-digit OTP"
                                            value={bookingOtp}
                                            onChange={(e) => setBookingOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
                                            maxLength={6}
                                            size="lg"
                                            textAlign="center"
                                            required
                                            type="text"
                                            inputMode="numeric"
                                            pattern="[0-9]*"
                                            autoComplete="one-time-code"
                                        />
                                        <HStack w="full"><Button size="sm" variant="ghost" onClick={sendBookingOtp}>Resend OTP</Button><Button colorScheme="brand" onClick={submitBooking} isLoading={bookingSubmitting} isDisabled={bookingTrim(bookingOtp).replace(/\D/g, "").length !== 6} w="full">Submit Booking</Button></HStack>
                                    </VStack>
                                )}
                            </VStack>
                        )}
                    </ModalBody>
                </ModalContent>
            </Modal>

            <Modal isOpen={isOtpModalOpen} onClose={() => setIsOtpModalOpen(false)} isCentered>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Mobile Verification</ModalHeader>
                    <ModalCloseButton />

                    <ModalBody>

                        {!confirmationResult && (
                            <>
                                <Input
                                    placeholder="Enter mobile number"
                                    value={mobileInput}
                                    onChange={(e) => setMobileInput(e.target.value)}
                                    mt={2}
                                />

                                <Box id="recaptcha-container" mt={4}></Box>

                                <Button colorScheme="brand" mt={4} onClick={sendOtp}>
                                    Send OTP
                                </Button>
                            </>
                        )}

                        {confirmationResult && (
                            <>
                                <Input
                                    placeholder="Enter OTP"
                                    value={otp}
                                    onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
                                    mt={2}
                                    type="text"
                                    inputMode="numeric"
                                    pattern="[0-9]*"
                                    autoComplete="one-time-code"
                                />

                                <Button colorScheme="green" mt={4} w="full" onClick={verifyOtp}>
                                    Verify OTP
                                </Button>

                                <Button
                                    variant="ghost"
                                    mt={3}
                                    onClick={sendOtp}
                                    isDisabled={!isResendEnabled}
                                >
                                    Resend OTP {isResendEnabled ? "" : `(${timer})`}
                                </Button>
                            </>
                        )}

                    </ModalBody>
                </ModalContent>
            </Modal>

            {/* MODALS */}
            {/* Plan Modal (isModal2Open) */}
            <Modal isOpen={isModal2Open} closeOnOverlayClick={false} size={{ base: "full", sm: "full", md: "5xl" }} onClose={closeModal2} scrollBehavior="inside">
                <ModalOverlay />
                <ModalContent p={6}>
                    <ModalHeader textAlign="center" pb={0}><Heading size="xl" color="brand.600">Select a Plan</Heading></ModalHeader>
                    <ModalCloseButton /><ModalBody>...</ModalBody>
                </ModalContent>
            </Modal>

            {/* Trending Modal (isModal1Open) */}
            <Modal blockScrollOnMount={false} isOpen={isModal1Open} onClose={closeModal1} size={{ base: 'full', md: 'lg', lg: '3xl' }}>
                <ModalOverlay /><ModalContent p={4}>...</ModalContent>
            </Modal>

            {/* Photo Upload Modal */}
            <PhotoUploadModal
                isOpen={isModalOpen}
                onClose={() => setIsModalOpen(false)}
                setIsModalOpen={setIsModalOpen}
                uploadedFiles={uploadedFiles}
                storeId={storeSingle.id}
                detailVendorGet={detailVendorGet}
                setUploadedFiles={setUploadedFiles}
            />

            {/* Review Submission Modal (isOpen) */}
            <Modal isOpen={isOpen} onClose={onClose}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader borderBottom="1px solid" borderColor="gray.100">Submit Your Review</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <Text mb={2}>Rating: <Badge colorScheme="yellow">{rating} Stars</Badge></Text>
                        <Textarea value={description} onChange={(e) => setDescription(e.target.value)} placeholder="Write your detailed review here..." rows={4} required />
                    </ModalBody>
                    <ModalFooter>
                        <Button colorScheme="brand" mr={3} onClick={handleSubmit}>Submit</Button>
                        <Button variant="ghost" onClick={onClose}>Close</Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            <Box display={{ base: "block", md: "none" }} w="100%" overflowX="auto" whiteSpace="nowrap" id="image-anchor" fontFamily={uiFontStack}>
                {storeImages.length > 0 ? (
                    <Flex
                        gap={2}
                        overflowX="scroll"
                        pb={2}
                        px={{ base: 0, md: 0 }}
                        sx={{ scrollbarWidth: "none", "&::-webkit-scrollbar": { display: "none" } }}
                    >
                        {storeImages.map((img, index) => (
                            <Box
                                key={index}
                                flex="0 0 100%"
                                h={{ base: "280px", sm: "300px" }}
                                position="relative"
                                borderRadius={{ base: "none", md: "md" }}
                                overflow="hidden"
                                onClick={() => navigate(`/gallery/${storeSingle.id}/${storeSingle.businessDetails.businessName}`)}
                            >
                                <Image
                                    src={apiAssetUrl(url, img)}
                                    alt={`Slide ${index + 1}`}
                                    w="100%"
                                    h="100%"
                                    objectFit="cover"
                                />
                            </Box>
                        ))}
                    </Flex>
                ) : (
                    <Box w="full" h="300px" bg="gray.200" display="flex" justifyContent="center" alignItems="center">
                        <Text fontSize="lg" color="gray.500">No images available</Text>
                    </Box>
                )}
            </Box>


            {/* IMAGE GALLERY (Corrected alignment and conditional rendering) */}
            <Box id="image-anchor" overflow="hidden" borderRadius={{ base: "0", md: "xl" }} shadow={{ base: "none", md: "lg" }} maxW="1200px" mx="auto" mt={{ base: 0, md: 4 }}
                display={{ base: "none", md: "block" }}
            >
                <Grid
                    templateColumns={{ base: "1fr", md: "repeat(4, 1fr)" }}
                    templateRows={{ base: "auto", md: "repeat(2, minmax(200px, 1fr))" }}
                    gap={{ base: 0, md: 2 }}
                >
                    {storeImages.length > 0 ? (
                        <>
                            {/* Image 1: Main Image (Spans 2x2 grid on desktop) */}
                            <Box gridColumn={{ base: "auto", md: "1 / 3" }} gridRow={{ base: "auto", md: "1 / 3" }} overflow="hidden" position="relative" h={{ base: "300px", md: "full" }} cursor="pointer" onClick={() => navigate(`/gallery/${storeSingle.id}/${storeSingle.businessDetails.businessName}`)}>
                                <Image src={apiAssetUrl(url, storeImages[0])} alt="Main Image" w="100%" h="100%" objectFit="cover" transition="transform 0.3s" _hover={{ transform: "scale(1.05)" }} fallback={<Box bg="gray.200" w="100%" h="100%" />} />
                            </Box>

                            {/* Remaining images (up to 4 more for grid on desktop) */}
                            {storeImages.slice(1, 5).map((img, index) => (
                                <Box key={index + 1} overflow="hidden" position="relative" h={{ base: "200px", md: "full" }} cursor="pointer" onClick={() => navigate(`/gallery/${storeSingle.id}/${storeSingle.businessDetails.businessName}`)}>
                                    <Image src={apiAssetUrl(url, img)} alt={`Image ${index + 2}`} w="100%" h="100%" objectFit="cover" transition="transform 0.3s" _hover={{ transform: "scale(1.05)" }} fallback={<Box bg="gray.200" w="100%" h="100%" />} />

                                    {(index === 3) && (storeImages.length > 5 || (login.permanent_ID === permanent_IDuser && storeImages.length < 6)) && (
                                        <Flex
                                            position="absolute" top="0" left="0" right="0" bottom="0"
                                            bg="rgba(0,0,0,0.5)" color="white"
                                            justify="center" align="center"
                                            fontSize="xl" fontWeight="bold"
                                            onClick={(e) => { e.stopPropagation(); storeImages.length > 5 ? navigate(`/gallery/${storeSingle.id}/${storeSingle.businessDetails.businessName}`) : setIsModalOpen(true) }}
                                        >
                                            {storeImages.length > 5 ? `+${storeImages.length - 4} More` : "Add Photos"}
                                        </Flex>
                                    )}
                                </Box>
                            ))}
                        </>
                    ) : (
                        <Box w="full" h="400px" bg="gray.200" display="flex" justifyContent="center" alignItems="center" gridColumn="1 / -1">
                            <Text fontSize="xl" color="gray.500">No images available</Text>
                        </Box>
                    )}
                </Grid>

                {storeImages.length > 0 && <DetailImageMobile detailVendorGet={detailVendorGet} storeSingle={storeSingle} formImages={storeImages} />}
            </Box>


            <Box
                maxW="1200px"
                mx="auto"
                id="detail-info-anchor"
                fontFamily={uiFontStack}
                px={{ base: 4, md: 6 }}
                py={{ base: 4, md: 5 }}
                className="detail-listing-profile-header"
            >
                {/* --- MAIN INFO (mobile: calmer hierarchy, system typography) --- */}
                <VStack align="stretch" spacing={{ base: 4, md: 5 }} mt={{ base: 0, md: 1 }}>
                    <Flex
                        justify="space-between"
                        align={{ base: "stretch", md: "flex-start" }}
                        w="full"
                        direction={{ base: "column", md: "row" }}
                        gap={{ base: 3, md: 4 }}
                    >
                        <Heading
                            as="h1"
                            color="gray.900"
                            fontWeight="600"
                            letterSpacing="-0.02em"
                            lineHeight={{ base: 1.3, md: 1.2 }}
                            fontSize={{ base: "1.375rem", sm: "1.5rem", md: "1.875rem", lg: "2.25rem" }}
                            pr={{ md: 6 }}
                        >
                            {storeSingle.businessDetails?.businessName || "Unknown Location"}
                        </Heading>
                        <HStack spacing={3} w={{ base: "full", md: "auto" }} flexShrink={0}>
                            {login.permanent_ID !== permanent_IDuser && (
                                <Button
                                    leftIcon={<i className="fa-solid fa-calendar-check" />}
                                    colorScheme="brand"
                                    size="md"
                                    w={{ base: "full", md: "auto" }}
                                    borderRadius="lg"
                                    fontWeight="600"
                                    py={6}
                                    onClick={handleBookingModalOpen}
                                >
                                    Contact now
                                </Button>
                            )}
                            {login.permanent_ID === permanent_IDuser && (
                                <Button
                                    leftIcon={<i className="fa-solid fa-pencil" />}
                                    colorScheme="brand"
                                    variant="outline"
                                    size="md"
                                    w={{ base: "full", md: "auto" }}
                                    borderRadius="lg"
                                    borderColor="gray.300"
                                    color="gray.800"
                                    onClick={openEdit}
                                >
                                    Edit listing
                                </Button>
                            )}
                        </HStack>
                    </Flex>

                    {/* Meta row: category · rating · count (readable, not crowded) */}
                    <Flex align="center" flexWrap="wrap" rowGap={2} columnGap={2} fontSize={{ base: "sm", md: "md" }}>
                        <Text fontWeight="600" color="gray.800">
                            {(storeSingle.subcategory && String(storeSingle.subcategory).trim()) || storeSingle.category || ""}
                        </Text>
                        {ratingTotal > 0 && (
                            <>
                                <Text as="span" color="gray.300" userSelect="none" aria-hidden>
                                    ·
                                </Text>
                                <Badge
                                    display="inline-flex"
                                    alignItems="center"
                                    px={2.5}
                                    py={0.5}
                                    borderRadius="full"
                                    fontSize="xs"
                                    fontWeight="600"
                                    bg="gray.100"
                                    color="gray.800"
                                >
                                    {averageRating?.toFixed(1)}
                                    <StarIcon w={3} h={3} ml={1} color="gray.600" />
                                </Badge>
                                <Text as="span" color="gray.300" userSelect="none" aria-hidden>
                                    ·
                                </Text>
                            </>
                        )}
                        <Text color="gray.500" fontSize={{ base: "sm", md: "sm" }}>
                            {ratingCountLabel}
                        </Text>
                    </Flex>

                    {/* Trust / verified + Share (Share styled to match Trust badge strip) */}
                    <HStack spacing={2} flexWrap="wrap" align="center">
                        {storeSingle?.trusted === true && <Image src={trust} alt="Trusted" h={{ base: "16px", md: "20px" }} />}
                        {storeSingle?.verified === true && <Image src={verified} alt="Verified" h={{ base: "16px", md: "20px" }} />}
                        <Button
                            type="button"
                            size="xs"
                            variant="unstyled"
                            display="inline-flex"
                            alignItems="center"
                            justifyContent="center"
                            gap={1}
                            px={2.5}
                            py={0.5}
                            minH={{ base: "22px", md: "26px" }}
                            h="auto"
                            bg="#F5D547"
                            color="gray.900"
                            borderRadius="md"
                            fontSize="xs"
                            fontWeight="700"
                            lineHeight="short"
                            _hover={{ bg: "#e6c63d", color: "gray.900" }}
                            _active={{ bg: "#d4b530" }}
                            onClick={() =>
                                handleShareClick(
                                    storeSingle.businessDetails?.businessName,
                                    storeSingle.contactDetails?.whatsapp,
                                    storeSingle.id
                                )
                            }
                        >
                            <Box as="i" className="fa-solid fa-share" aria-hidden fontSize="11px" />
                            Share
                        </Button>
                        {login.type === "vendor" && login.permanent_ID === permanent_IDuser && (
                            <Button
                                type="button"
                                size="xs"
                                variant="unstyled"
                                display="inline-flex"
                                alignItems="center"
                                justifyContent="center"
                                gap={1}
                                px={2.5}
                                py={0.5}
                                minH={{ base: "22px", md: "26px" }}
                                h="auto"
                                bg="orange.100"
                                color="gray.900"
                                borderWidth="1px"
                                borderColor="orange.300"
                                borderRadius="md"
                                fontSize="xs"
                                fontWeight="700"
                                lineHeight="short"
                                _hover={{ bg: "orange.200", color: "gray.900", borderColor: "orange.400" }}
                                _active={{ bg: "orange.300" }}
                                onClick={openModal1}
                                aria-label="Trending"
                            >
                                <StarIcon aria-hidden w={3} h={3} color="orange.600" />
                                Trending
                            </Button>
                        )}
                        {storeSingle?.claim === false && claimreq === "" ? (
                            <Button colorScheme="purple" size="sm" variant="ghost" onClick={handleClickClaim} fontWeight="600">
                                Claim this business
                            </Button>
                        ) : storeSingle?.claim === true ? (
                            <Badge colorScheme="green" display="inline-flex" alignItems="center" fontSize="xs" px={2.5} py={0.5} borderRadius="md">
                                <CheckCircleIcon mr={1} boxSize={3} /> Claimed
                            </Badge>
                        ) : claimreq === "Pending" ? (
                            <Badge colorScheme="orange" fontSize="xs" px={2.5} py={0.5} borderRadius="md">
                                Claim pending
                            </Badge>
                        ) : null}
                        {claimreq === "Active" && ispaid && login.type === "vendor" && (
                            <Button colorScheme="blue" size="sm" variant="outline" onClick={openModal2}>
                                Activate listing
                            </Button>
                        )}
                    </HStack>

                    {/* Location */}
                    <Flex align="flex-start" fontSize="sm" color="gray.600" lineHeight="tall" flexWrap="wrap" gap={2}>
                        <Box as="span" color="gray.400" mt={0.5}>
                            <i className="fa-solid fa-location-dot" />
                        </Box>
                        <Text flex="1" minW={0}>
                            {storeSingle.businessDetails &&
                                [storeSingle.businessDetails.city, storeSingle.businessDetails.state, storeSingle.businessDetails.pincode]
                                    .filter(Boolean)
                                    .join(", ")}
                        </Text>
                        {storeSingle.businessDate && calculateYearsInBusiness(storeSingle.businessDate) > 0 && (
                            <Text w={{ base: "100%", md: "auto" }} pl={{ base: 6, md: 0 }} fontWeight="500" color="gray.500" fontSize="xs">
                                {calculateYearsInBusiness(storeSingle.businessDate)} years in business
                            </Text>
                        )}
                    </Flex>

                    <Divider borderColor="gray.100" />

                    <Box
                            bg="gray.50"
                            borderRadius="xl"
                            borderWidth="1px"
                            borderColor="gray.100"
                            px={4}
                            py={3}
                            w="full"
                            className="detail-list-review-button"
                        >
                            <Text fontSize="xs" fontWeight="600" color="gray.500" textTransform="uppercase" letterSpacing="0.06em" mb={2}>
                                Rate this listing
                            </Text>
                            <HStack spacing={1} align="center">
                                {[...Array(5)].map((_, index) => (
                                    <StarIcon
                                        key={index}
                                        w={{ base: 5, md: 6 }}
                                        h={{ base: 5, md: 6 }}
                                        cursor="pointer"
                                        color={index < rating ? "#E2A032" : "#CBD5E0"}
                                        onClick={() => handleStarClick(index)}
                                        transition="color 0.15s ease"
                                    />
                                ))}
                            </HStack>
                        </Box>
                </VStack>

                {/* Edit Modal: scrollable body + fixed footer so Save stays visible on mobile */}
                {isEditOpen && (
                    <Box
                        className="detail-list-edit-overlay"
                        position="fixed"
                        inset={0}
                        bg="rgba(0,0,0,0.6)"
                        zIndex={15000}
                        display="flex"
                        alignItems={{ base: "flex-end", md: "center" }}
                        justifyContent="center"
                        overflowY="auto"
                        sx={{
                            WebkitOverflowScrolling: "touch",
                            py: { base: 0, md: 4 },
                        }}
                    >
                        <Box
                            className="detail-list-edit-modal"
                            bg="white"
                            shadow="2xl"
                            maxW="800px"
                            w={{ base: "100%", md: "90%" }}
                            maxH={{ base: "92dvh", md: "90vh" }}
                            borderRadius={{ base: "16px 16px 0 0", md: "lg" }}
                            display="flex"
                            flexDirection="column"
                            overflow="hidden"
                        >
                            <Flex flexShrink={0} justify="space-between" align="center" px={6} pt={5} pb={3} borderBottom="1px solid" borderColor="gray.100">
                                <Heading size="lg" color="brand.600">Edit Store Details</Heading>
                                <CloseIcon cursor="pointer" onClick={closeEdit} aria-label="Close" boxSize={5} />
                            </Flex>
                            <Box flex="1" minH={0} overflowY="auto" px={6} py={4}>
                                <form id="detail-listing-edit-form" onSubmit={handleFormSubmit}>
                                    <VStack spacing={4} align="stretch" pb={2}>
                                        <Box><Text fontWeight="bold" mb={1}>Store Name:</Text><Input type="text" name="storeName" value={formData.storeName} onChange={handleInputChange} required /></Box>
                                        <Box><Text fontWeight="bold" mb={1}>Address:</Text><Input type="text" name="address" value={formData.address} onChange={handleInputChange} required placeholder="Building, Street, Area, Landmark, City, State, Pincode" /></Box>
                                        <Stack direction={{ base: "column", md: "row" }} spacing={4}>
                                            <Box flex="1"><Text fontWeight="bold" mb={1}>Contact No.:</Text><Input type="text" name="contactNo" value={formData.contactNo} onChange={handleInputChange} required /></Box>
                                            <Box flex="1"><Text fontWeight="bold" mb={1}>WhatsApp No.:</Text><Input type="text" name="whatsappNo" value={formData.whatsappNo} onChange={handleInputChange} required /></Box>
                                        </Stack>
                                        <Box>
                                            <Text fontWeight="bold" mb={2}>Overview:</Text>
                                            <Box className="detail-edit-quill-wrap" sx={{ "& .ql-container": { minHeight: "140px", fontSize: "md" }, "& .ql-editor": { minHeight: "120px" } }}>
                                                <ReactQuill
                                                    theme="snow"
                                                    value={formData.overview || ""}
                                                    onChange={(value) => setFormData((prev) => ({ ...prev, overview: value }))}
                                                    placeholder="Business / profile description"
                                                />
                                            </Box>
                                        </Box>
                                        <Stack direction={{ base: "column", md: "row" }} spacing={4}>
                                            <Box flex="1">
                                                <Text fontWeight="bold" mb={1}>Category:</Text>
                                                <Select name="category" value={formData.category} onChange={handleInputChange} required>
                                                    <option value="">Select Category</option>
                                                    {categories.map((cat, idx) => (<option key={idx} value={cat.category_name}>{cat.category_name}</option>))}
                                                </Select>
                                            </Box>
                                            <Box flex="1">
                                                <Text fontWeight="bold" mb={1}>Subcategory:</Text>
                                                <Select name="subCategory" value={formData.subCategory} onChange={handleInputChange}>
                                                    <option value="">Select Subcategory</option>
                                                    {subCategories.map((subCat) => (
                                                        <option
                                                            key={subCat.id ?? subCat.subcategory_name}
                                                            value={subCat.subcategory_name ?? ""}
                                                        >
                                                            {subCat.subcategory_name ?? "N/A"}
                                                        </option>
                                                    ))}
                                                </Select>
                                            </Box>
                                        </Stack>
                                        <Box>
                                            <Text fontWeight="bold" mb={2}>Services:</Text>
                                            {formData.services.map((service, index) => (
                                                <HStack key={index} mb={2}>
                                                    <Input type="text" value={service} onChange={(e) => handleServiceChange(index, e.target.value)} />
                                                    <Button size="sm" onClick={() => removeServiceField(index)} colorScheme="brand" variant="ghost"><CloseIcon w={3} h={3} /></Button>
                                                </HStack>
                                            ))}
                                            <Button type="button" size="sm" colorScheme="blue" mt={2} onClick={addServiceField}>+ Add Service</Button>
                                        </Box>
                                        <Box>
                                            <Text fontWeight="bold" mb={2}>Business Hours:</Text>
                                            <Stack direction={{ base: "column", sm: "row" }} spacing={3}>
                                                <Select name="days" value={formData.businessHours.days} onChange={handleBusinessHoursChange}>
                                                    <option value="">Select Days</option>
                                                    {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sat-Sun", "Mon-Sat", "All-Days", "Always Open"].map(day => (<option key={day} value={day}>{day}</option>))}
                                                </Select>
                                                <Input type="time" name="open" value={formData.businessHours.open} onChange={handleBusinessHoursChange} />
                                                <Input type="time" name="close" value={formData.businessHours.close} onChange={handleBusinessHoursChange} />
                                            </Stack>
                                        </Box>
                                    </VStack>
                                </form>
                            </Box>
                            <Flex
                                flexShrink={0}
                                px={6}
                                py={3}
                                gap={3}
                                borderTop="1px solid"
                                borderColor="gray.100"
                                bg="white"
                                justify="flex-end"
                                align="center"
                                pb={{ base: "calc(12px + env(safe-area-inset-bottom, 0px))", md: 3 }}
                                boxShadow="0 -4px 12px rgba(0,0,0,0.06)"
                            >
                                <Button type="submit" form="detail-listing-edit-form" colorScheme="brand" size="lg" w={{ base: "full", md: "auto" }}>
                                    Save Changes
                                </Button>
                            </Flex>
                        </Box>
                    </Box>
                )}
            </Box>

            {/* --- Sticky Info Bar (Fixed positioning logic) --- */}
            <Box
                className={`detail-list-info-fixed`}
                position="fixed" top="0" w="100%" bg="white" zIndex="99"
                shadow="md" py={3} px={4}
                fontFamily={uiFontStack}
                borderBottomWidth="1px"
                borderBottomColor="gray.100"
                style={{
                    opacity: isVisible ? 1 : 0,
                    visibility: isVisible ? 'visible' : 'hidden',
                    transition: 'opacity 0.3s ease-in-out',
                }}
            >
                <Flex maxW="1200px" mx="auto" justify="space-between" align="center" gap={3}>
                    <VStack align="start" spacing={0} minW={0} flex="1">
                        <Heading size="sm" fontWeight="600" color="gray.900" noOfLines={1} letterSpacing="-0.01em">
                            {storeSingle.businessDetails?.businessName}
                        </Heading>
                        <HStack spacing={2} align="center" flexWrap="wrap">
                            {ratingTotal > 0 && (
                                <Badge display="inline-flex" alignItems="center" px={2} py={0} borderRadius="full" fontSize="10px" fontWeight="600" bg="gray.100" color="gray.800">
                                    {averageRating?.toFixed(1)} <StarIcon w={2.5} h={2.5} ml={0.5} />
                                </Badge>
                            )}
                            <Text fontSize="xs" color="gray.500">{ratingCountLabel}</Text>
                            {storeSingle.businessDetails?.city && (
                                <Text fontSize="xs" color="gray.400">· {storeSingle.businessDetails.city}</Text>
                            )}
                        </HStack>
                    </VStack>
                </Flex>
            </Box>


            <Box maxW="1200px" mx="auto" p={4} pt={0} fontFamily={uiFontStack}>
                {/* --- Section tabs: pill strip, scrollable on small screens (profile-style) --- */}
                <Box
                    className="detail-list-tabs"
                    mt={{ base: 5, md: 6 }}
                    mx={{ base: -4, md: 0 }}
                    px={{ base: 4, md: 0 }}
                    role="navigation"
                    aria-label="Listing sections"
                >
                    <Box
                        className="detail-list-tabs-rail"
                        bg={{ base: "gray.100", md: "gray.50" }}
                        borderRadius="2xl"
                        p={{ base: 1.5, md: 2 }}
                        borderWidth="1px"
                        borderColor={{ base: "gray.200", md: "gray.200" }}
                        boxShadow={{ base: "none", md: "sm" }}
                    >
                        <Flex
                            className="detail-list-tabs-scroll"
                            role="tablist"
                            aria-label="Jump to section"
                            gap={{ base: 2, md: 2 }}
                            overflowX="auto"
                            overflowY="hidden"
                            flexWrap="nowrap"
                            align="center"
                            py={0.5}
                            px={{ base: 0.5, md: 0.5 }}
                            sx={{
                                scrollSnapType: "x mandatory",
                                WebkitOverflowScrolling: "touch",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",
                                "&::-webkit-scrollbar": { display: "none" },
                            }}
                        >
                            {visibleDetailTabs.map((tab) => {
                                const active = activeTab === tab;
                                const icon = DETAIL_TAB_ICONS[tab];
                                const label = getDetailTabLabel(tab, additionalServicesTabLabel ?? "Additional Services");
                                return (
                                    <Button
                                        key={tab}
                                        ref={(el) => {
                                            detailTabBtnRefs.current[tab] = el;
                                        }}
                                        role="tab"
                                        aria-selected={active}
                                        aria-controls={tab}
                                        id={`tab-${tab}`}
                                        type="button"
                                        variant="unstyled"
                                        display="inline-flex"
                                        alignItems="center"
                                        justifyContent="center"
                                        flexDirection="row"
                                        gap={2}
                                        flexShrink={0}
                                        minH={{ base: "44px", md: "46px" }}
                                        px={{ base: 4, md: 5 }}
                                        py={2}
                                        borderRadius="full"
                                        fontSize={{ base: "sm", md: "md" }}
                                        fontWeight={active ? "600" : "500"}
                                        letterSpacing="-0.01em"
                                        color={active ? "brand.700" : "gray.600"}
                                        bg={active ? "white" : "transparent"}
                                        boxShadow={active ? "md" : "none"}
                                        borderWidth="1px"
                                        borderColor={active ? "gray.200" : "transparent"}
                                        transition="background 0.2s ease, color 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease"
                                        _hover={{
                                            bg: active ? "white" : "blackAlpha.50",
                                            color: active ? "brand.800" : "gray.800",
                                        }}
                                        _active={{ transform: "scale(0.98)" }}
                                        onClick={() => handleTabClick(tab)}
                                        sx={{ scrollSnapAlign: "start" }}
                                    >
                                        {icon && (
                                            <Box
                                                as="i"
                                                className={`fa-solid ${icon}`}
                                                aria-hidden
                                                fontSize={{ base: "0.75rem", md: "0.8rem" }}
                                                opacity={active ? 1 : 0.75}
                                            />
                                        )}
                                        <Text as="span" whiteSpace="nowrap">
                                            {label}
                                        </Text>
                                    </Button>
                                );
                            })}
                        </Flex>
                    </Box>
                </Box>

                <VStack spacing={10} mt={{ base: 6, md: 8 }} align="stretch">

                    {/* --- Product Section (Fixed Add Product link and logic) - Hidden for visitors when empty, always visible for owner --- */}
                    {showProductsSection && (
                    <Box id="product">
                        <Flex justify="space-between" align="center" mb={4}>
                            <Heading size="xl" color="gray.800">Products & Services</Heading>
                            {!ispaid && login.type === "vendor" && login.permanent_ID === permanent_IDuser && (
                                <Button colorScheme="brand" leftIcon={<i className="fa-solid fa-plus"></i>} as={Link} to={"/product"}>Add New Product</Button>


                            )}
                        </Flex>
                        <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }} gap={6}>
                            {mainProducts.length > 0 ? mainProducts.map((ele, idx) => {
                                const galleryPaths = getProductGalleryPaths(ele);
                                const thumbPath = galleryPaths[0] || ele.product_image;
                                const canOpenGallery = galleryPaths.length > 0;
                                return (
                                <Box key={ele.id ?? idx} className="detail-product-card">
                                    <Flex direction={{ base: "column", md: "row" }} align={{ md: "stretch" }}>
                                        <Box className="detail-card-image-wrap" flexShrink={0} mr={{ base: 0, md: 4 }} mb={{ base: 4, md: 0 }}>
                                            <Image
                                                src={apiAssetUrl(url, thumbPath)}
                                                alt={ele.product_name}
                                                className="detail-card-image"
                                                fallback={<Box bg="gray.200" w="100%" h="100%" minH="100px" borderRadius="lg" />}
                                                cursor={canOpenGallery ? 'pointer' : 'default'}
                                                onClick={() => { if (canOpenGallery) openProductGallery(ele); }}
                                                role={canOpenGallery ? 'button' : undefined}
                                                tabIndex={canOpenGallery ? 0 : undefined}
                                                onKeyDown={canOpenGallery ? (e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openProductGallery(ele); } } : undefined}
                                            />
                                            {galleryPaths.length > 1 ? (
                                                <Text fontSize="xs" color="gray.500" mt={1} textAlign={{ base: 'center', md: 'left' }}>
                                                    {galleryPaths.length} photos — click to view
                                                </Text>
                                            ) : null}
                                        </Box>
                                        <VStack align="start" flex="1" spacing={1} minW={0}>
                                            <Heading size="md" color="gray.700">{ele.product_name}</Heading>
                                            {
                                                isShort(ele.description) ? (
                                                    <Box
                                                        fontSize="md"
                                                        color="gray.700"
                                                        lineHeight="tall"
                                                        sx={{
                                                            "p, span": { marginBottom: "8px" },
                                                            "h1, h2, h3, h4, h5, h6": {
                                                                marginTop: "16px",
                                                                marginBottom: "8px",
                                                                fontWeight: "bold",
                                                                color: "gray.800",
                                                            },
                                                            "ul, ol": {
                                                                marginLeft: "20px",
                                                                paddingLeft: "20px",
                                                                marginBottom: "12px",
                                                            },
                                                            li: { marginBottom: "6px" },
                                                        }}
                                                        dangerouslySetInnerHTML={{ __html: ele.description || "" }}
                                                    />
                                                ) : (
                                                    <Text fontSize="sm" color="gray.600">
                                                        {getPreview(ele.description)}
                                                    </Text>
                                                )
                                            }



                                            {ele.quantity !== 0 && (<Text fontSize="sm" color="gray.500">Qty: {ele.quantity} {ele.unit || ""}</Text>)}
                                            {ele.shift_hour ? (
                                                <Text fontSize="sm" color="gray.500">
                                                    Hours: {ele.shift_hour}hrs
                                                </Text>
                                            ) : null}
                                            {ele.sell_price !== 0 && (<Text fontWeight="bold" color="brand.600" fontSize="lg">₹{ele.sell_price}</Text>)}


                                            {ele.datelaunched && (
                                                <Text color="gray.600" fontSize="sm">
                                                    Launched  {new Date(ele.datelaunched).getFullYear()}
                                                </Text>
                                            )}

                                        </VStack>
                                        <VStack justify="space-between" align={{ base: "stretch", md: "end" }} ml={{ base: 0, md: 4 }} mt={{ base: 4, md: 0 }} w={{ base: "full", md: "auto" }}>

                                            {login.permanent_ID === permanent_IDuser && (
                                                <HStack spacing={0} alignSelf={{ base: "flex-start", md: "auto" }}>
                                                    <Button
                                                        size="xs"
                                                        variant="ghost"
                                                        onClick={() => navigate(`/edit-product/${ele.id}`)}
                                                        colorScheme="gray"
                                                        aria-label="Edit product"
                                                    >
                                                        <i className="fa-solid fa-pen fa-sm"></i>
                                                    </Button>
                                                    <Button
                                                        size="xs"
                                                        variant="ghost"
                                                        colorScheme="red"
                                                        aria-label="Delete product"
                                                        isLoading={deletingProductId === ele.id}
                                                        onClick={() => handleDeleteProduct(ele)}
                                                    >
                                                        <i className="fa-solid fa-trash fa-sm"></i>
                                                    </Button>
                                                </HStack>
                                            )}
                                            <VStack align={{ base: "stretch", md: "end" }} spacing={2} w={{ base: "full", md: "auto" }}>
                                                {isLocationListing ? (
                                                    <Button
                                                        variant="outline"
                                                        colorScheme="brand"
                                                        size="sm"
                                                        w={{ base: "full", md: "auto" }}
                                                        onClick={() => setLocationDetailView({ open: true, product: ele })}
                                                    >
                                                        View details
                                                    </Button>
                                                ) : null}
                                                <Button colorScheme="brand" size="sm" onClick={() => handleAddCart(ele)} w={{ base: "full", md: "auto" }}>Add +</Button>
                                            </VStack>

                                        </VStack>
                                    </Flex>
                                </Box>
                                );
                            }) : (
                                <Text color="gray.500" fontSize="lg" gridColumn="1 / -1">No products currently listed.</Text>
                            )}
                        </Grid>

                        <Modal isOpen={productGallery.open} onClose={closeProductGallery} size="4xl" isCentered>
                            <ModalOverlay bg="blackAlpha.700" />
                            <ModalContent bg="gray.900" color="white" maxW="920px">
                                <ModalHeader borderBottomWidth="1px" borderColor="whiteAlpha.200">
                                    {productGallery.title}
                                    <Text as="span" fontSize="sm" fontWeight="normal" color="gray.400" ml={2}>
                                        {productGallery.urls.length
                                            ? `${productGallery.index + 1} / ${productGallery.urls.length}`
                                            : ''}
                                    </Text>
                                </ModalHeader>
                                <ModalCloseButton />
                                <ModalBody py={6} px={{ base: 4, md: 8 }}>
                                    {productGallery.urls.length > 0 ? (
                                        <>
                                            <Flex align="center" justify="center" gap={{ base: 2, md: 4 }}>
                                                <IconButton
                                                    aria-label="Previous image"
                                                    icon={<ChevronLeftIcon boxSize={8} />}
                                                    variant="ghost"
                                                    color="white"
                                                    onClick={() => stepProductGallery(-1)}
                                                    isDisabled={productGallery.urls.length < 2}
                                                />
                                                <Image
                                                    src={productGallery.urls[productGallery.index]}
                                                    alt=""
                                                    maxH={{ base: '48vh', md: '62vh' }}
                                                    maxW="100%"
                                                    objectFit="contain"
                                                    borderRadius="md"
                                                />
                                                <IconButton
                                                    aria-label="Next image"
                                                    icon={<ChevronRightIcon boxSize={8} />}
                                                    variant="ghost"
                                                    color="white"
                                                    onClick={() => stepProductGallery(1)}
                                                    isDisabled={productGallery.urls.length < 2}
                                                />
                                            </Flex>
                                            {productGallery.urls.length > 1 ? (
                                                <HStack mt={4} spacing={2} justify="center" flexWrap="wrap">
                                                    {productGallery.urls.map((u, i) => (
                                                        <Image
                                                            key={`${u}-${i}`}
                                                            src={u}
                                                            alt=""
                                                            boxSize="52px"
                                                            objectFit="cover"
                                                            borderRadius="md"
                                                            cursor="pointer"
                                                            opacity={i === productGallery.index ? 1 : 0.55}
                                                            outline={i === productGallery.index ? '2px solid white' : 'none'}
                                                            onClick={() => setProductGallery((g) => ({ ...g, index: i }))}
                                                        />
                                                    ))}
                                                </HStack>
                                            ) : null}
                                        </>
                                    ) : null}
                                </ModalBody>
                            </ModalContent>
                        </Modal>
                        <LocationDetailsReadOnlyModal
                            isOpen={locationDetailView.open}
                            onClose={() => setLocationDetailView({ open: false, product: null })}
                            productName={locationDetailView.product?.product_name}
                            locationDetails={locationDetailView.product?.location_details}
                            apiBase={url}
                        />
                    </Box>
                    )}

                    {showPortfolioSection && (
                    <Box id="portfolio" mt={10}>
                        <Flex justify="space-between" align="center" mb={4}>
                            <Heading size="xl" color="gray.800">Portfolio</Heading>

                            {/* Show add button only for listing owner */}
                            {!ispaid && login.type === "vendor" && login.permanent_ID === permanent_IDuser && (
                                <Button
                                    colorScheme="brand"
                                    leftIcon={<i className="fa-solid fa-plus"></i>}
                                    as={Link}
                                    to={"/project"}
                                >
                                    Add New Project
                                </Button>
                            )}
                        </Flex>

                        {/* CASE 1: NO PORTFOLIO PROJECTS */}
                        {portfolioProducts.length === 0 && (
                            <>
                                <Text color="gray.500" fontSize="lg" gridColumn="1 / -1">No project listed.</Text>

                                {/* Show add button only for owner */}
                                {!ispaid && login.type === "vendor" && login.permanent_ID === permanent_IDuser && (
                                    <Button
                                        colorScheme="brand"
                                        leftIcon={<i className="fa-solid fa-plus"></i>}
                                        as={Link}
                                        to={"/project"}
                                    >
                                        Add New Project
                                    </Button>
                                )}
                            </>
                        )}

                        {/* CASE 2: SHOW PORTFOLIO LIST */}
                        {portfolioProducts.length > 0 && (
                            <Grid
                                templateColumns={{
                                    base: "1fr",
                                    md: "repeat(2, 1fr)",
                                    lg: "repeat(3, 1fr)",
                                }}
                                gap={6}
                            >
                                {portfolioProducts.map((ele, idx) => (
                                    <Box key={ele.id ?? idx} className="detail-portfolio-card">
                                        <Flex direction={{ base: "column", md: "row" }} align={{ md: "stretch" }}>
                                            <Box className="detail-card-image-wrap" flexShrink={0} mr={{ base: 0, md: 4 }} mb={{ base: 4, md: 0 }}>
                                                <Image
                                                    src={apiAssetUrl(url, ele.product_image)}
                                                    alt={ele.product_name}
                                                    className="detail-card-image"
                                                    fallback={<Box bg="gray.200" w="100%" h="100%" minH="100px" borderRadius="lg" />}
                                                />
                                            </Box>

                                            <VStack align="start" flex="1" spacing={1} minW={0}>
                                                <Heading size="md" color="gray.700">
                                                    {ele.product_name}
                                                </Heading>

                                                <Text fontSize="sm" color="gray.600">
                                                    {getPreview(ele.description)}
                                                </Text>

                                                {ele.datelaunched && (
                                                    <Text color="gray.600" fontSize="sm">
                                                        Launched {new Date(ele.datelaunched).getFullYear()}
                                                    </Text>
                                                )}
                                            </VStack>

                                            <VStack justify="space-between" align={{ base: "stretch", md: "end" }} ml={{ base: 0, md: 4 }} mt={{ base: 4, md: 0 }} w={{ base: "full", md: "auto" }}>
                                                {login.permanent_ID === permanent_IDuser && (
                                                    <HStack spacing={0} alignSelf={{ base: "flex-start", md: "auto" }}>
                                                        <Button
                                                            size="xs"
                                                            variant="ghost"
                                                            onClick={() => navigate(`/edit-project/${ele.id}`)}
                                                            colorScheme="gray"
                                                            aria-label="Edit portfolio project"
                                                        >
                                                            <i className="fa-solid fa-pen fa-sm"></i>
                                                        </Button>
                                                        <Button
                                                            size="xs"
                                                            variant="ghost"
                                                            colorScheme="red"
                                                            aria-label="Delete portfolio project"
                                                            isLoading={deletingProductId === ele.id}
                                                            onClick={() => handleDeleteProduct(ele)}
                                                        >
                                                            <i className="fa-solid fa-trash fa-sm"></i>
                                                        </Button>
                                                    </HStack>
                                                )}

                                                <Button
                                                    colorScheme="brand"
                                                    size="sm"
                                                    onClick={() => navigate(`/castcrew/${ele.id}`)}
                                                    w={{ base: "full", md: "auto" }}
                                                >
                                                    View
                                                </Button>
                                            </VStack>
                                        </Flex>
                                    </Box>
                                ))}
                            </Grid>
                        )}
                    </Box>
                    )}



                    {/* --- Overview Section --- */}
                    <Box id="overview">
                        <Heading size="xl" mb={4} color="gray.800">Overview</Heading>
                        <Box p={6} bg="gray.50" borderRadius="lg" shadow="sm">
                            <Box
                                fontSize="md"
                                color="gray.700"
                                lineHeight="tall"
                                sx={{
                                    "p, span": {
                                        marginBottom: "8px",
                                    },
                                    "h1, h2, h3, h4, h5, h6": {
                                        marginTop: "16px",
                                        marginBottom: "8px",
                                        fontWeight: "bold",
                                        color: "gray.800",
                                    },
                                    "ul, ol": {
                                        marginLeft: "20px",   // add left spacing
                                        paddingLeft: "20px",
                                        marginBottom: "12px",
                                    },
                                    li: {
                                        marginBottom: "6px",  // add spacing between items
                                    }
                                }}
                                dangerouslySetInnerHTML={{
                                    __html:
                                        storeSingle.businessDetails?.description ||
                                        "No detailed overview provided for this listing.",
                                }}
                            />


                        </Box>
                    </Box>

                    {hasAnySocialLink(storeSingle.socialMediaLinks) && (
                        <Box id="social-links" mt={10}>
                            <Heading size="xl" mb={4} color="gray.800">Social Media Links</Heading>
                            <Flex flexWrap="wrap" gap={3} align="center">
                                {getFilledSocialLinks(storeSingle.socialMediaLinks).map((item) => (
                                    <Button
                                        key={item.key}
                                        as="a"
                                        href={item.url}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        leftIcon={<Box as="i" className={item.iconClass} aria-hidden />}
                                        variant="outline"
                                        colorScheme="brand"
                                        size="sm"
                                        borderRadius="full"
                                    >
                                        {item.label}
                                    </Button>
                                ))}
                            </Flex>
                        </Box>
                    )}

                    {/* --- Services Section --- */}
                    {storeSingle.additionalServices?.length > 0 && Array.isArray(storeSingle.additionalServices) && (
                        <Box id="services">
                            <Heading size="xl" mb={4} color="gray.800">Additional Services</Heading>
                            <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)", lg: "repeat(3, 1fr)" }} gap={4}>
                                {storeSingle.additionalServices.map((ele, idx) => (
                                    <Flex key={idx} align="center" p={3} bg="white" borderRadius="md" shadow="xs" borderLeft="4px solid" borderColor="brand.500">
                                        <CheckCircleIcon color="brand.500" mr={3} w={4} h={4} />
                                        <Text fontWeight="medium" color="gray.700">{ele}</Text>
                                    </Flex>
                                ))}
                            </Grid>
                        </Box>
                    )}

                    {/* --- Quick Info Section (Address and Business Hours Fixed) --- */}
                    <Box id="quick-info">
                        <Heading size="xl" mb={4} color="gray.800">Quick Info</Heading>
                        <Grid templateColumns={{ base: "1fr", md: "repeat(2, 1fr)" }} gap={6}>

                            {/* Business Hours (Fixed formatting) */}
                            <VStack align="start" spacing={3} p={5} bg="white" borderRadius="lg" shadow="md">
                                <HStack>
                                    <TimeIcon color="brand.500" w={5} h={5} />
                                    <Text fontWeight="bold" fontSize="lg">Business Hours:</Text>
                                </HStack>
                                <VStack align="start" spacing={1} fontSize="md" pl={6}>
                                    {storeSingle.businessTiming?.timeSlots?.length > 0 ? storeSingle.businessTiming.timeSlots.map((slot, index) => (
                                        <Text key={index} color="gray.700">
                                            {slot.day || "N/A"}: {formatTime(slot.openTime)} - {formatTime(slot.closeTime)}
                                        </Text>
                                    )) : <Text color="gray.500">Hours not specified.</Text>}
                                </VStack>
                            </VStack>

                            {/* Contact Info */}
                            <VStack align="start" spacing={3} p={5} bg="white" borderRadius="lg" shadow="md">
                                <HStack>
                                    <PhoneIcon color="brand.500" w={5} h={5} />
                                    <Text fontWeight="bold" fontSize="lg">Contact Details:</Text>
                                </HStack>
                                <VStack align="start" spacing={1} fontSize="md" pl={6}>
                                    {storeSingle.contactDetails?.mobile && <Text><i className="fa-solid fa-mobile-alt" style={{ marginRight: "8px" }}></i> {callNumber}</Text>}
                                    {storeSingle.contactDetails?.whatsapp && <Text><i className="fa-brands fa-whatsapp" style={{ color: "#25D366", marginRight: "8px" }}></i> {whatsappNumber}</Text>}
                                    {!storeSingle.contactDetails?.mobile && !storeSingle.contactDetails?.whatsapp && <Text color="gray.500">Contact not available.</Text>}
                                </VStack>
                            </VStack>

                            {/* Address (Enhanced Visibility) */}
                            <VStack align="start" spacing={3} p={5} bg="white" borderRadius="lg" shadow="md" gridColumn={{ base: "auto", md: "1 / -1" }}>
                                <HStack>
                                    <i className="fa-solid fa-location-dot" style={{ color: "#0041FF", fontSize: "1.25rem" }}></i>
                                    <Text fontWeight="bold" fontSize="lg">Location Address:</Text>
                                </HStack>
                                <Text fontSize="md" pl={6} color="gray.700">
                                    {storeSingle.businessDetails && [
                                        storeSingle.businessDetails.buildingName, storeSingle.businessDetails.street, storeSingle.businessDetails.area,
                                        storeSingle.businessDetails.landmark, storeSingle.businessDetails.city, storeSingle.businessDetails.state,
                                        storeSingle.businessDetails.pincode
                                    ].filter(Boolean).join(', ') || "Full address not available."}
                                </Text>
                            </VStack>
                        </Grid>
                    </Box>

                    {/* --- Review Section (Fixed rating display) --- */}
                    <Box id="review">
                        <Heading size="xl" mb={4} color="gray.800">Customer Reviews</Heading>
                        <VStack spacing={6} align="stretch">
                            {ratingData.length > 0 ? (
                                ratingData.map((review, index) => (
                                    <Box key={index} p={5} bg="white" borderRadius="lg" shadow="md" borderLeft="4px solid" borderColor="yellow.400">
                                        <HStack align="center" mb={3}>
                                            <Image src={user} alt={review.user_name} boxSize="40px" borderRadius="full" objectFit="cover" fallback={<Box bg="gray.200" boxSize="40px" borderRadius="full" />} />
                                            <Text fontWeight="bold" fontSize="lg">{review.user_name}</Text>
                                            <Badge ml={3} colorScheme="yellow" display="flex" alignItems="center" px={2}>{review.rating_point} <StarIcon w={3} h={3} ml={1} /></Badge>
                                        </HStack>
                                        <Box className='review-tab-para'>
                                            <Text fontStyle="italic" color="gray.700">"{review.description}"</Text>
                                        </Box>
                                    </Box>
                                ))
                            ) : (
                                <Box p={5} bg="gray.50" borderRadius="lg" textAlign="center">
                                    <Text color="gray.500" fontSize="lg">No reviews yet. Be the first to share your experience!</Text>
                                </Box>
                            )}
                        </VStack>
                    </Box>
                </VStack>
            </Box>
        </>
    );
};

export default DetailPageVendor;